import React, { Component } from 'react';
import '../../css/dataTables.css';
import moment from 'moment';
import $, { event } from 'jquery';
import { ApiClient } from '../../libs/apiClient';
import { NewItem, Permissions } from '../NewOrder';
import { json, CURRENCY } from '../../libs/utils/Const';
import config from "../../config";
import DataXML from '../DataXML';
import { _ROUND, FORMAT_NUMBER, } from "../../libs/utils/Const";
import ConfirmModal from '../confirmModal';
import { BranchesModal, GenericTable, ItemsCreateModal, StandardSelectModal, WarningModal } from "../index"
import AlmacenModal from '../AlmacenModal';
import SeriesCreateModal from '../SeriesCreateModal';
const apiClient = ApiClient.getInstance();


class SuggestRefillModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            editMode: false,
            viewTabRefill: 2,
            pageTotal: 0,
            items: [],
            chooseRefillItems: [],
            ListItemsGroup: [],
            mountItemCreateModal: false,
            mountStandarSelectM: false,
            warehouses: [],
            itemSelected: '',
            series: [],
            showWarningModal: false,
            branches: [],
        };
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () {
            window.location.hash = "no-back-button";
        }
    }

    componentDidMount = async () => {
        const { newOrderModel } = this.props
        this._handelBack();
        await this.SetBranchOfficeInfo();
        const wareHouseData = {
            ItemCode: null,
            TransferType: null,
            whsCode: '',
        }
        const getAlmacenResponse = await apiClient.getWarehouseList(wareHouseData);
        this.setState({ wareHousesList: getAlmacenResponse?.data ?? [] });
        this.refreshTotal(newOrderModel);
    }

    UpdateStateField = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    restartTabs = () => {
        $('#nav-profile-tab-Contenido-D').removeClass('active');
        $('#nav-profile-tab-Finanzas').removeClass('active');
        $('#nav-profile-tab-logistica').removeClass('active');
        $('#nav-profile-tab-Costs-D').removeClass('active');

        $('#dataContenidoDocument').removeClass('active');
        $('#dataFinanzas').removeClass('active');
        $('#dataLogistica').removeClass('active');
        $('#dataCostsDocument').removeClass('active');

        $('#dataContenidoDocument').removeClass('show');
        $('#dataFinanzas').removeClass('show');
        $('#dataLogistica').removeClass('show');
        $('#dataCostsDocument').removeClass('show');

        $('#nav-profile-tab-Contenido-D').addClass('active');
        $('#dataContenidoDocument').addClass('active')
        $('#dataContenidoDocument').addClass('show')
    };

    SetBranchOfficeInfo = () => {
        const { _user } = this.state
        this.setState({
            U_FMB_DEF_PLInventoryGenExitService: _user?.Branch?.U_FMB_DEF_PLInventoryGenExitService || null,
            U_FMB_DEF_PLInventoryGenEntryService: _user?.Branch?.U_FMB_DEF_PLInventoryGenEntryService || null,
            U_FMB_DEF_PLStockTransfer: _user?.Branch?.U_FMB_DEF_PLStockTransfer || null,
            U_FMB_DEF_PLReqStockTransfer: _user?.Branch?.U_FMB_DEF_PLReqStockTransfer || null,
        })
    }

    openAction = () => {
        $('#SuggestRefillModal').on('hide.bs.modal', function () {
        });
    };

    closeModalCreate = async () => {

        const { action, CloseDocumentModal } = this.props
        if (action === 1) {
            $('#confirmModal').modal('show');
        } else {

            $('#SuggestRefillModal').modal('hide');
            await CloseDocumentModal();
        }
        this.setState({
            service: 'I'
        });
    };

    isMarketingDocument = (view) => {
        return (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'billing' || view === 'invoiceAdvance' || view === 'invoiceReserve' || view === 'return' || view === 'creditNote' || view === 'pendingTimbraDocs')
    }

    validatePartner = () => {
        const { newOrderModel, view } = this.props;

        if (view === 'suggestRefill' || view === 'transfers' || view === 'transfersRequest') {
            return true;
        }

        if (newOrderModel.CardCode !== '' && newOrderModel.CardName !== '') {
            return true;
        }

        return false;
    };

    validatePersonRequest = () => {
        const { newOrderModel, view } = this.props;

        if (view === 'transfers') {
            return true;
        }

        if (newOrderModel.Requester !== '') {
            return true;
        }
        return false;
    }

    selectTo = async event => {
        const { showAlert, newOrderModel, changeDocumentActionModal, view, enableSpinner, selectTable, selectValidateSeries } = this.props;
        const select = event.nativeEvent.target.value;
        const today = moment(new Date()).format('YYYY-MM-DD');

        newOrderModel.isSelectToActive = true;
        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        const commentDocumentorigin = table => {
            let name = '';

            switch (table) {
                case 'orderSales':
                    name = 'orden de venta';
                    break;
                case 'invoice':
                    name = 'factura';
                    break;
                case 'deliveries':
                    name = 'entrega';
                    break;
                case 'return':
                    name = 'devolución';
                    break;
                case 'creditNote':
                    name = 'nota de crédito';
                    break;
                case 'debitNote':
                    name = 'nota de debito';
                    break;
                case 'PurchaseOrder':
                    name = 'orden de compra';
                    break;
                case 'GoodsReceipt':
                    name = 'entrada de mercancía';
                    break;
                case 'SalesHelmets':
                    name = 'entrada de mercancía cascos';
                    break;
                case 'invoiceReserve':
                    name = 'factura de reserva de clientes';
                    break;
                case 'purchaseInvoice':
                    name = 'factura de proveedores';
                    break;
                case 'purchaseCreditNotes':
                    name = 'factura de proveedores';
                    break;
                case 'transfersRequest':
                    name = 'Solicitud de Traslado';
                    break;
                case 'suggestRefill':
                    name = 'Sugerido de resurtido';
                    break;

                default:
                    break;
            }
            return name;
        };

        let newItems = [];
        let newService = [];
        // Limpiar para no llevar el folio de Counter
        newOrderModel.NumAtCard = '';
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];

            if (!item.LineStatus) {
                if (view !== 'suggestRefill') {
                    item.BaseEntry = newOrderModel.DocEntry;
                    item.BaseType = newOrderModel.ObjType;
                    item.BaseLine = item.LineNum;
                }

                item.LineStatus = false;
                item.RevenuesAc = item.AcctCode;

                let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;

                if (view === 'transfersRequest') {
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        for (let index = 0; index < item.wareHouseStock.length; index++) {
                            const warehouse = item.wareHouseStock[index];
                            if (warehouse.WhsCode === newOrderModel.Filler) {
                                if (warehouse.OnHand <= 0) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                        timeOut: 5000
                                    });
                                    item.stock = false;
                                } else {
                                    item.stock = true;
                                }
                            }
                        }
                    }
                } else {
                    for (let index = 0; index < item.wareHouseStock.length; index++) {
                        const warehouseStock = item.wareHouseStock[index];

                        if (warehouseStock.WhsCode.toString() === item.WhsCode.toString()) {
                            item.OnHand = warehouseStock.OnHand || 0;
                            if (warehouseStock.OnHand <= 0 && item.BaseType !== '15') {
                                showAlert({
                                    type: 'warning',
                                    message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                    timeOut: 5000
                                });
                                item.stock = false;

                            } else if (((item.UserBaseUn === 'Y' && item.Quantity > warehouseStock.OnHand) || (item.UserBaseUn === 'N' && (item.Quantity * measureUnit) > warehouseStock.OnHand)) && item.BaseType !== '15') {
                                showAlert({
                                    type: 'warning',
                                    message: 'El artículo ' + item.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                    timeOut: 5000
                                });
                                item.stock = false;
                            } else {
                                item.stock = true;
                            }
                        }
                    }
                }

                if ((view === 'invoice' && select === 'creditNote') || (view === 'invoiceReserve' && select === 'creditNote')) {
                    item.HomePrice = item.PriceBefDi;
                }

                if (item.UserBaseUn === 'Y') {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2);
                    item.newPrice = parseFloat(item.Price).toFixed(2);
                    item.cHomePrice = parseFloat(item.Price).toFixed(2);
                    item.cPrice = parseFloat(item.Price).toFixed(2);
                } else {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.newPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.cHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.cPrice = parseFloat(item.Price).toFixed(2) / measureUnit;

                    if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'purchaseReturn') {
                        item.newHomePrice = parseFloat(item.Price).toFixed(2);
                        item.newPrice = parseFloat(item.Price).toFixed(2);
                        item.cHomePrice = parseFloat(item.Price).toFixed(2);
                        item.cPrice = parseFloat(item.Price).toFixed(2);
                    }
                }


                newItems.push(item);

            }
        }
        newOrderModel.Items = newItems;
        newOrderModel.service = newService;

        let comment = ' Basado en ' + commentDocumentorigin(newOrderModel.OriginDocumentCreate) + ' ' + (view === 'suggestRefill' ? newOrderModel.NumAtCard : newOrderModel.NextFolio);
        newOrderModel.OriginDocumentCreate = select || '';
        newOrderModel.newView = newOrderModel.OriginDocumentCreate;
        if (view !== 'invoiceReserve' && select === 'deliveries') {//SET VALUE FOR AUTHORIZATION BY LEVEL 1214,1215,1216
            newOrderModel.DeliveryAuthorization = 'I'
        }
        newOrderModel.Comments += comment;
        newOrderModel.isDocumentWithAuthorization = false;
        let table = selectTable(newOrderModel.OriginDocumentCreate);

        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse.data;

        //cambio de moneda de dolares y detener so el documento no tiene el tipo de cambio

        let currency = newOrderModel.Currencies.filter((currency) => currency.CurrCode === newOrderModel.DocCur);

        if (!currency.length) {
            showAlert({
                type: 'error',
                timeOut: 5000,
                message: "No se a definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
            })
            return;
        }

        newOrderModel.ChangeRate = currency[0].Rate || 1;

        const dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let ValidateSeries = selectValidateSeries(table.name, user);

        if (!user || ValidateSeries.series === "") {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrió un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < seriesResponse.data.length; index++) {
                const serieResponse = seriesResponse.data[index];
                if (Number(serieResponse.Series) === Number(serieUser)) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (newArraySeries.length === 1) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }

        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";


        // newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
        newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
        newOrderModel.U_FMB_TIPO_REL = '01';
        newOrderModel.U_UDF_UUID = '';
        newOrderModel.U_FMB_SELLO = '';
        newOrderModel.U_FMB_SERIE = '';
        newOrderModel.U_FMB_FOLIO = '';


        let permissions = new Permissions();

        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        //guardar orign de documento para ccines de copiar a:

        //ACCIONES UE CAMBIAN EL MODELO EN EL PASO DE DOCUEMMNTOS A:

        //dE ORDEN DE VENTA A FACTURA
        newOrderModel.DocDate = today;
        newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
        //Calculo fecha de entrega 
        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {

            newOrderModel.DocDate = today;
            newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
            // let grouNum = newOrderModel.GroupNum;
            // let groupName = newOrderModel.GroupName;
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;
            if (typeInvoice === 0) {
                typeInvoice = extraDays ? extraDays : 3;
            }
            let docDueDate = new Date(today);/*new Date(newOrderModel.DocDueDate)*/
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        } else {
            newOrderModel.DocDueDate = today;
        }

        // newOrderModel.Items.map(item => {
        //     item.Quantity = item.OpenQty;
        //     return item;
        // });
        if (view === 'invoiceReserve') {
            let newArreglo = [];
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                if (element.TargetType !== 14 && select === 'creditNote') {
                    element.Quantity = element.ActualOpenQty ? element.ActualOpenQty : element.Quantity;
                    newArreglo.push(newOrderModel.Items[index])
                } else if ((element.TargetType !== 15 && select === 'deliveries' && element.Quantity !== 0) || element.ActualOpenQty !== 0) {
                    newArreglo.push(newOrderModel.Items[index])
                }
            }
            newOrderModel.Items = newArreglo;
        }

        //validacion para evitar que salga la pestaña de coppiar de cuando pasas a copiar a
        newOrderModel.isSelectTo = true;
        newOrderModel.isSelectOf = true;

        //Asignar Series de usuario
        //CENTROS DE COSTOS 
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const element = newOrderModel.Items[index];
            //CENTRO DE COSTO 1
            element.OcrCode = element.OcrdCode;
            //CENTRO DE COSTO 2
            element.OcrCode2 = newOrderModel.OcrCode2;
            //CENTRO DE COSTO 3
            // element.OcrCode3 = element.OcrCode3;
            //CENTRO DE COSTO 4
            element.OcrCode4 = '';
        }
        //CENTROS DE COSTOS 

        newOrderModel.U_FMB_WHS_TYPE = user?.Branch?.U_FMB_WHS_TYPE || "";
        if (user?.Branch?.U_FMB_WHS_TYPE === '7') {
            newOrderModel.Filler = user?.Branch?.U_FMB_PLANTA || "";
            newOrderModel.ToWhsCode = user?.Branch?.ProjectCode || "";
        }

        this.refreshTotal(newOrderModel);

        changeDocumentActionModal();
        this.restartTabs();
    };

    duplicate = async () => {
        const { showAlert, newOrderModel, changeDocumentActionModal, view, enableSpinner, selectTable, selectValidateSeries } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        //cambio de moneda de dolares y detener so el documento no tiene el tipo de cambio
        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse.data;

        let currency = newOrderModel.Currencies.filter(currency => {
            return currency.CurrCode.toString() === newOrderModel.DocCur.toString();
        });

        if (!currency.length) {
            showAlert({
                type: 'error',
                timeOut: 5000,
                message: "No se a definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
            })
            return;
        }

        newOrderModel.ChangeRate = currency[0].Rate || 1;

        let newItems = [];

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            item.BaseEntry = null;
            item.BaseType = -1;
            item.BaseLine = null;
            item.LineStatus = false;
            let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            for (let index = 0; index < item.wareHouseStock.length; index++) {
                const warehouseStock = item.wareHouseStock[index];
                if (warehouseStock.WhsCode.toString() === item.WhsCode.toString()) {
                    item.OnHand = warehouseStock.OnHand || 0;
                    if (warehouseStock.OnHand <= 0) {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                            timeOut: 5000
                        });
                        item.stock = false;
                    } else if ((item.UserBaseUn === 'Y' && item.Quantity > warehouseStock.OnHand) ||
                        (item.UserBaseUn === 'N' && (item.Quantity * measureUnit) > warehouseStock.OnHand)) {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + item.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                            timeOut: 5000
                        });
                        item.stock = false;
                    } else {
                        item.stock = true;
                    }
                }
            }
            if (item.UserBaseUn === 'Y') {
                item.newHomePrice = parseFloat(item.Price).toFixed(2);
                item.newPrice = parseFloat(item.Price).toFixed(2);
                item.cHomePrice = parseFloat(item.Price).toFixed(2);
                item.cPrice = parseFloat(item.Price).toFixed(2);
            } else {
                item.newHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.newPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.cHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.cPrice = parseFloat(item.Price).toFixed(2) / measureUnit;

                if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'purchaseReturn') {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2);
                    item.newPrice = parseFloat(item.Price).toFixed(2);
                    item.cHomePrice = parseFloat(item.Price).toFixed(2);
                    item.cPrice = parseFloat(item.Price).toFixed(2);
                }
            }
            if (newOrderModel.DocStatus === 'C') { item.OpenQty = parseFloat(item.Quantity).toFixed(6); }
            item.Quantity = item.OpenQty;
            newItems.push(item);
        }

        this.refreshTotal(newOrderModel);

        newOrderModel.Items = newItems;
        newOrderModel.OriginDocumentCreate = view;
        newOrderModel.newView = newOrderModel.OriginDocumentCreate;
        newOrderModel.isDocumentWithAuthorization = false;
        let table = selectTable(newOrderModel.OriginDocumentCreate);





        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);



        let ValidateSeries = selectValidateSeries(table.name, user);

        if (!user || ValidateSeries.series === "") {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < seriesResponse.data.length; index++) {
                const serieResponse = seriesResponse.data[index];
                if (serieResponse.Series.toString() === serieUser.toString()) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (serie.Series.toString() === newArraySeries[0].DfltSeries.toString()) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }


        let today = moment(new Date()).format('YYYY-MM-DD');
        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";


        let permissions = new Permissions();
        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        //guardar orign de documento para ccines de copiar a:

        //ACCIONES UE CAMBIAN EL MODELO EN EL PASO DE DOCUEMMNTOS A:

        //dE ORDEN DE VENTA A FACTURA
        newOrderModel.DocDate = today;
        newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
        //Calculo fecha de entrega 
        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {

            newOrderModel.DocDate = today;
            newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
            // let grouNum = newOrderModel.GroupNum;
            // let groupName = newOrderModel.GroupName;
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;

            if (Number(typeInvoice) === 0) {
                typeInvoice = extraDays ? extraDays : 3;
            }
            let docDueDate = new Date(today);
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        } else {
            newOrderModel.DocDueDate = today;
        }


        this.refreshModel(newOrderModel);


        changeDocumentActionModal();
    };

    selectOf = async event => {
        const { showAlert, newOrderModel, view } = this.props;
        let message = 'Selecciona un socio de negocios';

        if (view === 'landedCosts') {
            message = 'Selecciona un proveedor'
        }

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message });
            return;
        }
        newOrderModel.SelectOf = event.nativeEvent.target.value || '';

        this.refreshModel(newOrderModel);
        this.selectOfReference.enableDataTable();
        $('#selectOfModal').modal('show');
    };

    changeQuantityItem = async (event, index, specifQty = null) => {
        const { showAlert, newOrderModel } = this.props;

        // let docDate = newOrderModel.DocDate;
        // let cardCode = newOrderModel.CardCode;
        // let itemCode = newOrderModel.Items[index].ItemCode;
        let quantity = specifQty !== null ? specifQty : event.nativeEvent.target.value;


        // if( quantity.indexOf(".") !== -1 ){
        //    showAlert({type: 'warning', message: "Solo se permiten cantidades enteras"});
        //    return;
        // }      
        if (quantity.indexOf(" ") !== -1 || quantity.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }
        // Validación para que al copiar a factura no respete cantidad de documento origen
        // if(quantity > newOrderModel.Items[index].OriginalQuantity && (newOrderModel.isSelectTo || newOrderModel.isSelectOf ) && !newOrderModel.Items[index].ItemNew)
        // {
        //     showAlert({type: 'warning', message: "La cantidad excede a la cantidad original"});
        //     quantity=newOrderModel.Items[index].quantity;
        // }



        if (!isNaN(quantity) && quantity !== '') {
            newOrderModel.Items[index].Quantity = quantity;
            //#region ########## BATCH #######################
            if (newOrderModel.Items[index].ManBtchNum === 'Y') {
                newOrderModel.Items[index].DocUoMQty = Number(quantity);
                newOrderModel.Items[index].OpenLneQty = Number(quantity) - Number(newOrderModel.Items[index].SnBUoMQty);
            }
            //#endregion
        } else if (quantity === '') {
            newOrderModel.Items[index].Quantity = '';
        }
        setTimeout(() => {
            this.refreshTotal(newOrderModel, index);
        }, 100);

    };

    changeSearchItem = async (event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.searchItem = event.nativeEvent.target.value.trim();
        }
        this.refreshTotal(newOrderModel);
    };

    changeAlmacen = async (index, event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.Items[index].WhsCode = event.nativeEvent.target.value;
            newOrderModel.Items[index].whsSelected = false;
            newOrderModel.Items[index].AcctCode = '';
            newOrderModel.Items[index].AcctCode2 = '';
            newOrderModel.Items[index].AvgPrice = 0;
        }
        this.refreshModel(newOrderModel);
    };

    refreshModel = newOrderModel => {
        const { refreshModel } = this.props;
        refreshModel(newOrderModel);
    };

    refreshTotal = (newOrderModel, index = null) => {
        const { action } = this.props;
        if (index || index === 0) {


            newOrderModel.Items[index].Price = parseFloat(newOrderModel.Items[index].HomePrice).toFixed(2);

            let discount = newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity * (newOrderModel.Items[index].DiscountPercent / 100);
            newOrderModel.Items[index].Discount = discount || 0;

            let impuesto = parseFloat(((newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity - newOrderModel.Items[index].Discount)).toFixed(2)) * (newOrderModel.Items[index].TaxeRate / 100);
            newOrderModel.Items[index].TaxeResult = impuesto.toFixed(2);
            let total = 0;
            total = (newOrderModel.Items[index].Price / newOrderModel.ChangeRate) * newOrderModel.Items[index].Quantity - (newOrderModel.Items[index].Discount / newOrderModel.ChangeRate);

            newOrderModel.Items[index].Total = total;


        } else {

            newOrderModel.Items.map(item => {
                item.Price = Number(Number(item.HomePrice)).toFixed(2);
                let discount = item.Price * item.Quantity * (item.DiscountPercent / 100);
                item.Discount = discount || 0;

                let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? _ROUND(item.ImpuestoRow / newOrderModel.ChangeRate) : _ROUND(parseFloat(((item.Price * item.Quantity - item.Discount)).toFixed(2)) * (item.TaxeRate / 100));
                item.TaxeResult = impuesto.toFixed(2);
                let total = 0;
                total = (item.Price / newOrderModel.ChangeRate) * item.Quantity - (item.Discount / newOrderModel.ChangeRate);
                item.Total = item.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? _ROUND(item.LineTotal / newOrderModel.ChangeRate) : _ROUND(total);
                if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
                    item.Total = _ROUND(item.LineTotal / newOrderModel.ChangeRate);
                }
            });

        }

        let subTotal = 0;
        let impuestos = 0;
        let discount = 0;
        let total = 0;


        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            let discount = parseFloat(item.Total * ((newOrderModel.DiscountPercent || 0) / 100)).toFixed(2);

            let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true && action == 1 ? _ROUND(item.ImpuestoRow / newOrderModel.ChangeRate) : _ROUND(parseFloat(((item.Total - discount)).toFixed(2)) * (item.TaxeRate / 100));
            item.TaxeResult = Number(Number(impuesto)).toFixed(2);


            subTotal += Number(item.Total);
            impuestos += parseFloat(Number(item.TaxeResult).toFixed(2));
        }

        let iva = (impuestos * 100) / subTotal;
        let subtotalDpm = subTotal - newOrderModel.DpmAmnt;
        discount = subtotalDpm * (newOrderModel.DiscountPercent / 100);
        impuestos = subtotalDpm * (iva / 100);
        total = parseFloat(parseFloat(subtotalDpm).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));


        newOrderModel.Subtotal = Number(subTotal.toFixed(2));
        newOrderModel.Discount = Number(discount.toFixed(2));
        newOrderModel.Taxes = Number(impuestos.toFixed(2));
        newOrderModel.Total = Number(total.toFixed(2));

        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.CheckSum = 0;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
            newOrderModel.totalPago += Number(item.totalPago);
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }

        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur !== newOrderModel.DocCurDocumentsPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;
        this.refreshModel(newOrderModel);

    };

    refreshTotalService = (newOrderModel, index = null) => {
        if (index || index === 0) {

            let total = 0;
            newOrderModel.service[index].Price = parseFloat(newOrderModel.service[index].HomePrice / newOrderModel.ChangeRate) || '';
            let impuesto = (newOrderModel.service[index].Price) * (newOrderModel.service[index].TaxeRate / 100);
            newOrderModel.service[index].TaxeResult = parseFloat(impuesto).toFixed(2);

            total = newOrderModel.service[index].Price;
            newOrderModel.service[index].Total = total;

        } else {
            newOrderModel.service.map(item => {
                let total = 0;
                item.Price = (item.HomePrice / newOrderModel.ChangeRate).toFixed(2);
                let impuesto = item.Price * (item.TaxeRate / 100);
                item.TaxeResult = parseFloat(impuesto).toFixed(2);

                total = item.Price;
                item.Total = total;
            });

        }


        let subTotal = 0;
        let impuestos = 0;
        let discount = 0;
        let total = 0;

        newOrderModel.service.map(item => {
            subTotal += Number(item.Total);
            impuestos += parseFloat(item.TaxeResult);
        });

        newOrderModel.Subtotal = subTotal;
        newOrderModel.Taxes = impuestos;
        newOrderModel.Discount = discount;

        total = newOrderModel.Subtotal + impuestos;

        newOrderModel.Total = total;
        this.refreshModel(newOrderModel);
    };

    openAddresses = async type => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        if (newOrderModel.Addresses.length > 0) {
            $('#addressesModal').modal('show');
            return;
        }
        enableSpinner(true);
        let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
        enableSpinner(false);

        let data = [];
        if (type === 1) {
            if (getAddressResponse.data.deliveriesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }

            data = getAddressResponse.data.deliveriesAddress;
        } else {
            if (getAddressResponse.data.invoicesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            data = getAddressResponse.data.invoicesAddress;
        }

        newOrderModel.Addresses = data;
        this.setState({
            newOrderModel,
        });

        $('#addressesModal').modal('show');

    };

    selectAddresses = action => {
        const { newOrderModel } = this.props;
        let address = newOrderModel.Addresses[action.index];

        newOrderModel.TaxeDefaultPartner = address.TaxCode;
        newOrderModel.TaxeRateDefaultPartner = !!address.TaxCodeRate && address.TaxCodeRate !== null ? address.TaxCodeRate : 16;
        newOrderModel.ShipToCode = address.Address;
        newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";

        this.refreshModel(newOrderModel);
        $('#addressesModal').modal('hide');

    };

    edditAddres = async (index) => {
        const { newOrderModel } = this.props;
        await this.setState({
            editAddress: Object.assign({}, newOrderModel.Addresses[index]),
        });
        $('#addressModal').modal('show');
    };

    refreshAddress = async (editAddress) => {
        await this.setState({
            editAddress,
        });
    }

    aceptEditAddress = async (editAddress) => {
        const { newOrderModel } = this.props;
        newOrderModel.Addresses.map((address) => {
            if (address.Address === editAddress.Address) {
                address.Street = editAddress.Street;
                address.Block = editAddress.Block;
                address.City = editAddress.City;
                address.ZipCode = editAddress.ZipCode;
                address.County = editAddress.County;
                address.Country = editAddress.Country;
                address.State = editAddress.State;
            }
            return address
        });

        newOrderModel.ShipToCode = editAddress.Address;
        newOrderModel.Address2 = (editAddress.Street ? editAddress.Street : '') + ' ' + (editAddress.Block ? editAddress.Block : '') + '  ' + (editAddress.City ? editAddress.City : '') + ' ' + (editAddress.ZipCode ? editAddress.ZipCode : '') + ' ' + (editAddress.State ? editAddress.State : '') + ' ' + (editAddress.Country ? editAddress.Country : '') || "";

        await this.setState({
            newOrderModel,
            editAddress: null
        });

        $('#addressModal').modal('hide');
    }

    openConfirm = async () => {
        await this.setState({ showWarningModal: true });
        $("#warningModal").modal("show");
        $("#warningModal").on("hidden.bs.modal", async () => {
            await this.setState({ showWarningModal: false });
        });
    }

    sendModel = () => {
        const { newOrderModel, createDocument, view, showAlert, SendSuggestRefillModel } = this.props;
        let newView = newOrderModel.newView || view;
        //Factura de reserva de clientes
        if (newView === 'invoiceReserve') {
            newOrderModel.ReserveInvoice = 'tYES';
        }

        if (view === 'payment') {
            let reconciliacion = false;
            newOrderModel.ItemsPayments.map(Item => {
                if (Item.docType === '14') {
                    reconciliacion = true;
                }
            });
            if (!reconciliacion) {
                if (newOrderModel.totalRecibido != newOrderModel.totalPago) {
                    showAlert({
                        type: 'error',
                        message: 'El total del documento no corresponde al total de dinero recibido'
                    });
                    return;
                }
            } else if ((newOrderModel.totalRecibido <= 0 || newOrderModel.totalRestante < -0.01) && reconciliacion) {
                showAlert({
                    type: 'error',
                    message: 'El total del documento no corresponde al total de dinero recibido'
                });
                return;
            }
        }

        if (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve' || view === "quotations") {
            let limit = newOrderModel.Balance + newOrderModel.Total - newOrderModel.CreditLine;
            if (limit >= 1) {
                showAlert({ type: 'error', message: newOrderModel.CardCode + ' - ' + newOrderModel.CardName + ' Límite de crédito excedido en ' + parseFloat(limit).toFixed(2) + ' ' + newOrderModel.DocCur });
            }
        }

        // Validación de lista de precios para documentos de inventario
        if (view === 'transfersRequest' || view === "transfers" || view === 'transfersEntry' || view === 'transfersOutput') {
            let error = false;
            const priceListNum = (newOrderModel.GroupNum === -2 || newOrderModel.GroupNum === -1) ? newOrderModel.GroupNum + 1 : newOrderModel.GroupNum;
            for (let i = 0; i < newOrderModel.Items.length; i++) {
                const item = newOrderModel.Items[i];
                if (!item.PricesList || item.PricesList.length === 0) continue;

                const Price = item?.PricesList?.find(({ PriceList }) => PriceList === Number(priceListNum))?.Price ?? 0;
                if (!Price || Number(Price) === 0) {
                    showAlert({ type: 'warning', message: item.ItemCode + ` no cuenta con un precio valido` });
                    error = true;
                    break;
                }
            }
            if (error) return;
        }

        if (newOrderModel.DocType === 'S' && (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve' || view === "quotations")) {
            let error = false;
            newOrderModel.service.map(service => {
                if (service.AcctCode === '') {
                    showAlert({ type: 'warning', message: 'Seleccione una cuenta de mayor para la descripción ' + service.Description });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (newOrderModel.DocType === 'I' && view !== 'inventoryData' && view !== 'bussinesPartner' && view !== 'transfersRequest' && view !== 'transfers') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.WhsCode === '') {
                    showAlert({
                        type: 'warning',
                        message: 'Seleccione un almacén para el artículo ' + Item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view !== 'suggestRefill' && view !== 'inventoryData' && view !== 'bussinesPartner' && view !== 'transfersRequest' && view !== 'transfers' && view !== 'inventoryRevaluation' && view !== 'PurchaseRequest') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.Price === '0.00') {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ` Su precio es de ${CURRENCY} 0.00`
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view === 'inventoryRevaluation') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.NewAvgPrice === 0) {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ' Su costo nuevo no puede ser 0'
                    });
                    error = true;
                }
            });

            if (error) {
                return;
            }

            newOrderModel.Items.map(Item => {
                if (Item.NewAvgPrice <= 0) {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ' Su costo nuevo no puede ser negativo'
                    });
                    error = true;
                }
            });

            if (error) {
                return;
            }
        }

        if (view === 'transfersEntry' || view === 'transfersOutput') {
            if (!newOrderModel.U_TipoSalida || newOrderModel.U_TipoSalida === '') {
                showAlert({ type: 'error', message: 'Selecciona un tipo de Salida/Entrada valido' });
                return;
            }
            let error = 0;
            let message = '';
            for (let index in newOrderModel.Items) {
                const Item = newOrderModel.Items[index];

                if (Item.Price === '0.00' || Number(Item.Price || '0') === 0) {
                    error = 1;
                    message = `El artículo ${Item.ItemCode} no cuenta con un precio valido`;
                }
                if (Item.WhsCode.toUpperCase() === 'SAP-R1' || Item.WhsCode.toUpperCase() === 'R1-R1') {
                    error = 2;
                    message = 'No esta permitido usar el almacén seleccionado para esta operación';
                }
                if (view === 'transfersOutput') {
                    let whsStock = Item.wareHouseStock?.find(({ WhsCode }) => WhsCode === Item?.WhsCode) || { OnHand: 0 };
                    if (Number(whsStock.OnHand) === 0) {
                        error = 3;
                        message = `El artículo ${Item.ItemCode} no cuenta con stock en el almacén seleccionado`;
                    } else if (Number(whsStock.OnHand) < Number(Item.Quantity)) {
                        error = 3;
                        message = `El artículo ${Item.ItemCode} no cuenta con stock suficiente en el almacén seleccionado`;
                    }
                }
                if (error !== 0) break;
            }

            if (error !== 0) {
                showAlert({ type: 'warning', message });
                return;
            }
        }

        if (view === 'transfersRequest' || view === 'transfers') {
            if (newOrderModel.Transit.toString() !== '2') {
                if (newOrderModel.Filler === "" || newOrderModel.ToWhsCode === "") {
                    showAlert({ type: "warning", message: "Asegúrese de llenar de forma correcta los almacenes" });
                    return;
                }
                if (newOrderModel.ToWhsCode === newOrderModel.Filler) {
                    showAlert({ type: 'warning', message: 'El almacén destino no puede ser el mismo que el almacén de origen' });
                    return;
                }
            }
            if (newOrderModel.Filler.toUpperCase() === "SAP-R1" || newOrderModel.Filler.toUpperCase() === "R1-R1") {
                showAlert({ type: 'warning', message: 'No esta permitido usar el almacén de origen seleccionado para esta operación' });
                return;
            }
        }

        if (view === 'transfers' && newOrderModel.Transit.toString() === '2') {
            if (newOrderModel.DocNumCEDIS === '') {
                showAlert({ type: "warning", message: "Si seleccionas el tipo de traslado 'Recuperar de CEDIS' debes de agregar un numero de documento ", timeOut: 5000 });
                return;
            }
            if (newOrderModel.WarehouseCEDIS === '') {
                showAlert({ type: "warning", message: "Si seleccionas el tipo de traslado 'Recuperar de CEDIS' debes de agregar el almacen a donde se realizara la entrada de mercancia ", timeOut: 5000 });
                return;
            }

        }

        if (view === 'SalesHelmets') {
            // newOrderModel.NumAtCard = '';
            // newOrderModel.NumAtCard += ' Entrada Cascos: ' + newOrderModel.NextFolio;
            //newOrderModel.ref2 += newOrderModel.NextFolio2;
            // if(newOrderModel.isSelectTo)
            // {
            //     newOrderModel.NumAtCard = '';
            //     newOrderModel.NumAtCard += ' Salida Cascos: ' + newOrderModel.NextFolio;
            // }

            let error = false;
            newOrderModel.Items.map(item => {
                if (item.AcctCode === '') {
                    showAlert({
                        type: 'warning',
                        message: 'Asegurese de presionar la tecla ENTER al almacén de ' + item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }

        }

        if (view === 'ExitHelmets') {
            // newOrderModel.NumAtCard = '';
            // newOrderModel.NumAtCard += ' Salida Cascos: ' + newOrderModel.NextFolio;
            //newOrderModel.ref2 += newOrderModel.NextFolio2;

            let error = false;
            newOrderModel.Items.map(item => {
                if (item.AcctCode === '') {
                    showAlert({
                        type: 'warning',
                        message: 'Asegurese de presionar la tecla ENTER al almacén de ' + item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view !== 'inventoryData' && view !== 'bussinesPartner') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.Quantity === '0') {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede ser 0'
                });
                return;
            }
            newOrderModel.Items.map(Item => {
                if (Item.Quantity < 0) {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede ser negativa'
                });
                return;
            }
            newOrderModel.Items.map(Item => {
                if (Item.Quantity === '') {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede esta vacia'
                });
                return;
            }

        }

        if (view === 'ExitHelmets' && !newOrderModel.SerieCode2) {
            showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Débito" });
            return;
        }

        if (view === 'SalesHelmets' && !newOrderModel.SerieCode2) {
            if (newOrderModel.isSelectTo) {
                showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Débito" });
                return;
            }
            showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Crédito" });

            return;
        }

        if (!newOrderModel.SerieCode && view !== 'suggestRefill' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'bussinesPartner' && view !== 'inventoryRevaluation' && view !== 'reportSelectionCriteria') {
            showAlert({ type: 'warning', message: "Selecciona una serie valida" });
            return;
        }
        if ((!newOrderModel.TaxeDefaultPartner || newOrderModel.TaxeDefaultPartner === '') && this.isMarketingDocument(view)) {
            showAlert({ type: 'error', message: 'El socio no cuenta con indicador de impuestos en su dirección de entrega' }, 5000);
            return;
        }

        if (newOrderModel.newView !== 'suggestRefill') {
            createDocument(newOrderModel);
        } else {
            SendSuggestRefillModel(newOrderModel);
        }

    };

    showDocs = async (arrDocs) => {
        const { showDocs } = this.props
        $('#SuggestRefillModal').modal('hide');
        await showDocs(arrDocs, this.state.listOrderRecommendation)
    }

    selectItems = async itemsSelected => {
        const { newOrderModel, showAlert, view, selectTable } = this.props;
        let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let OcrCode4DefaultItems = '';
        if (newOrderModel.Items.length) {
            OcrCode4DefaultItems = newOrderModel.Items[0] ? newOrderModel.Items[0].OcrCode4 : '';
        }

        // let whCode = user.U_whsCode || null;;
        // let almacen = {
        //     item: itemsSelected[0].ItemCode,
        //     whsCode: whCode || '',
        //     Cascos: true
        // };
        // let AlmacenCascos = [];
        // if (view === 'SalesHelmets' && whCode) {
        //     AlmacenCascos = await apiClient.getWarehouse(almacen);
        //     if (AlmacenCascos.data[0]) {
        //         newOrderModel.CashAcct = AlmacenCascos.data[0].CashAccount || '';
        //         newOrderModel.BpAct = AlmacenCascos.data[0].ControlAccount || '';
        //     }
        // }
        // let whsCascos = AlmacenCascos.data ? AlmacenCascos.data[0] : null;


        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];
            let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;

            const newItemModel = new NewItem();
            newItemModel.LineNum = newOrderModel.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Description = item.ItemName;
            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(2);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(2);
            } else {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(2) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(2) * Number(measureUnit);
            }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.InvntItem = item.InvntItem || '';
            newItemModel.SalUnitMsr = item.SalUnitMsr || '';
            newItemModel.BuyUnitMsr = item.BuyUnitMsr || '';
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.OnHand = item.OnHand || 0;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.NoPriceList = item.PriceList;
            newItemModel.SalPackUn = item.SalPackUn;
            newItemModel.PurPackUn = item.PurPackUn;
            newItemModel.RevenuesAc = item.RevenuesAc;
            newItemModel.AvgPrice = item.AvgPrice;
            newItemModel.ManBtchNum = item.ManBtchNum;
            newItemModel.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));

            if (item.EvalSystem === 'A') {
                newItemModel.EvalSystem = "Promedio móvil";
            } else if (item.EvalSystem === 'B') {
                newItemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                newItemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                newItemModel.EvalSystem = "Estándar";
            }
            //#region CENTROS DE COSTOS 

            //CENTRO DE COSTO 1
            if (view !== 'transfers' && view !== 'transfersRequest' && view !== 'transfersEntry' && view !== 'transfersOutput') {
                newItemModel.OcrCode = item.OcrdCode;
            }
            //CENTRO DE COSTO 2
            newItemModel.OcrCode2 = newOrderModel.OcrCode2;
            //CENTRO DE COSTO 3
            newItemModel.OcrCode3 = item.OcrCode3;
            //CENTRO DE COSTO 4
            newItemModel.OcrCode4 = item.OcrCode4;;

            //#endregion CENTROS DE COSTOS 

            //#region ######################## IVA DEFAULT #####################################
            let taxCode = '';
            let taxRate = ''
            if (view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve') {
                taxCode = item.TaxCodeAR;
                taxRate = item.TaxeRate
            } else {
                taxCode = item.TaxCodeAP;
                taxRate = item.TaxeRateAP;
            }
            newItemModel.TaxCode = taxCode || newOrderModel.TaxeDefaultPartner;
            newItemModel.TaxeRate = taxRate || newOrderModel.TaxeRateDefaultPartner;
            //#endregion

            //#region ######################## ALMACEN DEFAULT ############################################

            let projectWhs = user.Branch.ProjectCode || null;

            if (projectWhs) {
                newItemModel.whsSelected = true;
                newItemModel.WhsCode = projectWhs;

                newItemModel.WhsName = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].WhsName : '';
                newItemModel.AcctCode = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode : '';
                newItemModel.AcctCode2 = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode2 : '';
                newItemModel.AcctCodeName = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctName : '';
                newItemModel.FormatCode = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode : '';
                newItemModel.FormatCode2 = user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode2 : '';
                if (newOrderModel.U_TipoSalida !== '') {
                    let data = {
                        Type: newOrderModel.U_TipoSalida,
                        WhsCode: newItemModel.WhsCode,
                    }

                    let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                    if (responseGetAcctCode.status === 1) {
                        if (responseGetAcctCode.data[0].AcctCode !== '') {
                            const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                            const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                            const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                            newItemModel.FormatCode = resultado;
                            newItemModel.AcctCode = cuentaOriginal;
                        }
                    }
                }
            }
            let Almacen = item.wareHouses.find((whs) => whs.WhsCode === newItemModel.WhsCode);
            newItemModel.AvgPrice = Almacen ? Almacen.AvgPrice : item.AvgPrice;
            // Precio x Kilo
            let PriceKilo = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
            newItemModel.PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            newItemModel.UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            // Precio x Kilo
            //#endregion
            if (view === 'transfersRequest' || view === 'transfers') {
                let noList = parseInt(newOrderModel.GroupNum);
                noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
                let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

                newItemModel.Price = price[0].Price;
                newItemModel.HomePrice = price[0].Price;
            }

            if (newOrderModel.AcctCodeDefaultPartner) {
                newItemModel.AcctCode = newOrderModel.AcctCodeDefaultPartner || newItemModel.AcctCode;
                newItemModel.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || newItemModel.AcctCodeName;
            }

            if (newOrderModel.CogsAcctDefaultPartner) {
                newItemModel.CogsAcct = newOrderModel.CogsAcctDefaultPartner || newItemModel.CogsAcct;
                newItemModel.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || newItemModel.CogsAcctName;
            }


            // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel.GroupNum !== '') {
                let numList = parseInt(newOrderModel.GroupNum);
                numList = (numList === -1 || numList === -2) ? numList + 1 : numList;
                for (let i = 0; i < item.itemPrice.length; i++) {
                    let list = item.itemPrice[i].PriceList;
                    if (list == numList) {
                        newItemModel.HomePrice = item.itemPrice[i].Price;
                        newItemModel.Price = item.itemPrice[i].Price;
                    }
                }
            }

            //validate warehoyse stock
            if (newItemModel.InvntItem === 'Y' && (view === 'transfers' || view === 'transfersRequest')) {
                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    if (warehouseStock.WhsCode === newOrderModel.Filler) {
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else {
                            newItemModel.stock = true;
                        }

                    }
                }

            } else if (newItemModel.InvntItem === 'Y' && (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve')) {

                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newItemModel.SalPackUn : newItemModel.PurPackUn;
                    if (warehouseStock.WhsCode === newItemModel.WhsCode) {
                        newItemModel.OnHand = warehouseStock.OnHand || 0;
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else if ((newItemModel.UserBaseUn === 'Y' && newItemModel.Quantity > warehouseStock.OnHand) ||
                            (newItemModel.UserBaseUn === 'N' && (newItemModel.Quantity * measureUnit) > warehouseStock.OnHand)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;
                        } else {
                            newItemModel.stock = true;
                        }
                    }
                }

            }
            newOrderModel.Items.push(newItemModel);
        }

        newOrderModel.searchItem = '';
        this.refreshTotal(newOrderModel);

        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

        $('#itemsCreate').modal('hide');
    };

    selectItemsEnter = async itemsSelected => {
        const { newOrderModel, showAlert, view } = this.props;
        const { _user } = this.state
        // let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        newOrderModel.UserID = _user.USERID;

        if ((!newOrderModel.TaxeDefaultPartner || newOrderModel.TaxeDefaultPartner === '') && this.isMarketingDocument(view)) {
            showAlert({ type: 'error', message: 'El socio no cuenta con indicador de impuestos en su dirección de entrega' }, 5000);
            return;
        }

        let OcrCode4DefaultItems = '';
        if (newOrderModel.Items.length) {
            OcrCode4DefaultItems = newOrderModel.Items[0] ? newOrderModel.Items[0].OcrCode4 : '';
        }

        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];
            const newItemModel = new NewItem();
            newItemModel.LineNum = newOrderModel.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Description = item.ItemName;

            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price).toFixed(2);
                newItemModel.Price = parseFloat(item.Price).toFixed(2);

            } else {
                let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(2) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(2) * Number(measureUnit);
            }

            if ((view === "PurchaseOrder" || view === "PurchaseRequest") && Number(item?.Price ?? '0') === 0) {
                showAlert({ type: 'warning', message: 'El artículo ' + item.ItemCode + ' no tiene un precio valido asignado.', timeOut: 5000 });
            }

            // if (view === 'SalesHelmets' && whsCascos) {
            //     newItemModel.AcctCode = whsCascos.AcctCode || '';
            //     newItemModel.AcctCodeName = whsCascos.AcctName || '';
            //     newItemModel.WhsCode = whsCascos.WhsCode;
            //     newItemModel.WhsName = whsCascos.WhsName;
            // }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.InvntItem = item.InvntItem || '';
            newItemModel.SalUnitMsr = item.SalUnitMsr || '';
            newItemModel.BuyUnitMsr = item.BuyUnitMsr || '';
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.OnHand = item.OnHand || 0;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.NoPriceList = item.PriceList;
            newItemModel.SalPackUn = item.SalPackUn;
            newItemModel.PurPackUn = item.PurPackUn;
            newItemModel.RevenuesAc = item.RevenuesAc;
            newItemModel.AvgPrice = item.AvgPrice;
            newItemModel.ManBtchNum = item.ManBtchNum;
            newItemModel.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));

            if (item.EvalSystem === 'A') {
                newItemModel.EvalSystem = "Promedio móvil";
            } else if (item.EvalSystem === 'B') {
                newItemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                newItemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                newItemModel.EvalSystem = "Estándar";
            }

            //#region CENTROS DE COSTOS 
            //CENTRO DE COSTO 1
            newItemModel.OcrCode = item.OcrdCode;
            //CENTRO DE COSTO 2
            newItemModel.OcrCode2 = newOrderModel.OcrCode2;
            //CENTRO DE COSTO 3
            newItemModel.OcrCode3 = item.OcrCode3;
            //CENTRO DE COSTO 4
            newItemModel.OcrCode4 = item.OcrCode4;;

            //#endregion

            //#region ######################## IVA DEFAULT ################################################
            let taxCode = '';
            let taxRate = ''
            if (view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve') {
                taxCode = item.TaxCodeAR;
                taxRate = item.TaxeRate
            } else {
                taxCode = item.TaxCodeAP;
                taxRate = item.TaxeRateAP;
            }
            newItemModel.TaxCode = taxCode || newOrderModel.TaxeDefaultPartner;
            newItemModel.TaxeRate = taxRate || newOrderModel.TaxeRateDefaultPartner;
            //#endregion

            //#region ######################## ALMACEN DEFAULT ############################################


            let projectWhs = _user.Branch.ProjectCode || null;

            if (projectWhs) {
                newItemModel.whsSelected = true;
                newItemModel.WhsCode = projectWhs;

                newItemModel.WhsName = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].WhsName : '';
                newItemModel.AcctCode = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].AcctCode : '';
                newItemModel.AcctCode2 = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].AcctCode2 : '';
                newItemModel.AcctCodeName = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].AcctName : '';
                newItemModel.FormatCode = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].FormatCode : '';
                newItemModel.FormatCode2 = _user.Branch.AccountDefault ? _user.Branch.AccountDefault[0].FormatCode2 : '';
                if (newOrderModel.U_TipoSalida !== '') {
                    let data = {
                        Type: newOrderModel.U_TipoSalida,
                        WhsCode: newItemModel.WhsCode,
                    }

                    let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                    if (responseGetAcctCode.status === 1) {
                        if (responseGetAcctCode.data[0].AcctCode !== '') {
                            const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                            const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                            const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                            newItemModel.FormatCode = resultado;
                            newItemModel.AcctCode = cuentaOriginal;
                        }
                    }
                }
            }
            let Almacen = item.wareHouses.find((whs) => whs.WhsCode === newItemModel.WhsCode);
            newItemModel.AvgPrice = Almacen ? Almacen.AvgPrice : item.AvgPrice;

            // Precio x Kilo
            let PriceKilo = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
            newItemModel.PrecioXKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            newItemModel.PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            newItemModel.UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            // Precio x Kilo

            //#endregion
            if (view === 'transfersRequest' || view === 'transfers') {
                let noList = parseInt(newOrderModel.GroupNum);
                noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
                let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

                newItemModel.Price = price[0].Price;
                newItemModel.HomePrice = price[0].Price;
            }

            if (newOrderModel.AcctCodeDefaultPartner) {
                newItemModel.AcctCode = newOrderModel.AcctCodeDefaultPartner || newItemModel.AcctCode;
                newItemModel.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || newItemModel.AcctCodeName;
            }

            if (newOrderModel.CogsAcctDefaultPartner) {
                newItemModel.CogsAcct = newOrderModel.CogsAcctDefaultPartner || newItemModel.CogsAcct;
                newItemModel.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || newItemModel.CogsAcctName;
            }


            // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel.GroupNum !== '') {
                let numList = parseInt(newOrderModel.GroupNum);
                numList = (numList === -1 || numList === -2) ? numList + 1 : numList;
                for (let i = 0; i < item.itemPrice.length; i++) {
                    let list = item.itemPrice[i].PriceList;
                    if (list === numList) {
                        newItemModel.HomePrice = item.itemPrice[i].Price;
                        newItemModel.Price = item.itemPrice[i].Price;
                    }
                }
            }
            //validate warehoyse stock
            if (newItemModel.InvntItem === 'Y' && (view === 'transfers' || view === 'transfersRequest')) {
                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    if (warehouseStock.WhsCode === newOrderModel.Filler) {
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else {
                            newItemModel.stock = true;
                        }
                    }
                }
            } else if (newItemModel.InvntItem === 'Y' && (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve')) {

                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newItemModel.SalPackUn : newItemModel.PurPackUn;
                    if (warehouseStock.WhsCode === newItemModel.WhsCode) {
                        newItemModel.OnHand = warehouseStock.OnHand || 0;
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else if ((newItemModel.UserBaseUn === 'Y' && newItemModel.Quantity > warehouseStock.OnHand) ||
                            (newItemModel.UserBaseUn === 'N' && (newItemModel.Quantity * measureUnit) > warehouseStock.OnHand)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;
                        } else {
                            newItemModel.stock = true;
                        }
                    }

                }

            }

            newOrderModel.Items.push(newItemModel);
        }

        newOrderModel.searchItem = '';

        await this.refreshTotal(newOrderModel);
        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

    };

    getPartner = async (value) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;


        let type = 'C'
        if (view == 'PurchaseOrder' || view == 'purchaseReturn' || view === 'GoodsReceipt') {
            type.type = 'S';
        }

        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartnerListCreateLike(type, value);
        enableSpinner(false);

        if (!Array.isArray(getPartnerResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getPartnerResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        return getPartnerResponse;

    };

    changeCardCode = async (event) => {
        const { newOrderModel } = this.props;
        this.clearSocio(event.nativeEvent.target.name);
        if (event.nativeEvent.data !== '') {
            if (event.nativeEvent.target.name !== 'AgentCode') {
                newOrderModel.CardCode = event.nativeEvent.target.value;
            } else {
                newOrderModel.AgentCode = event.nativeEvent.target.value;
            }
        }
        // this.refreshModel(newOrderModel);
    };

    changeComments = event => {
        const { newOrderModel, showAlert } = this.props;
        let value = event.nativeEvent.target.value
        if (value.length > 250) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida' });
        }
        newOrderModel.Comments = value;
        this.refreshModel(newOrderModel);
    };

    deleteItem = async (indexToDelete) => {
        const { newOrderModel } = this.props;
        let newItems = [];
        let hasBaseEntry = false;
        let flagProm = false;

        newOrderModel.Items.map((item, index) => {
            if (indexToDelete !== index) {
                if (item.BaseEntry) {
                    hasBaseEntry = true;
                }
                newItems.push(item);
            }
            return null;
        });

        newOrderModel.isSelectTo = hasBaseEntry;
        newOrderModel.Items = newItems;

        this.refreshModel(newOrderModel);
        setTimeout(() => {
            this.refreshTotal(newOrderModel);
        }, 500);
    };

    openItems = async (searchingItem = null) => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        let searchItem = searchingItem !== null ? searchingItem : newOrderModel.searchItem;

        if ((view === 'transfersRequest' || view === 'transfers') && !newOrderModel.Filler && searchingItem === null) {
            showAlert({ type: 'info', message: 'Selecciona primero un almacén de origen' });
            return;
        }
        if (!this.validatePartner() && view !== 'suggestRefill' && view !== 'transfersRequest' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'PurchaseRequest') {
            showAlert({ type: 'error', message: 'Selecciona un socio de negocios o por favor presiona Enter al seleccionar socio de negocios' });
            return;
        }
        if (!this.validatePersonRequest() && view === 'PurchaseRequest') {
            showAlert({ type: 'info', message: 'Selecciona primero un Solicitante' });
            return;
        }

        enableSpinner(true);
        let getItemResponse = await apiClient.getItem(newOrderModel.CardCode, view, searchItem);
        enableSpinner(false);

        if (getItemResponse.data.length === 0) {

            if (!Array.isArray(getItemResponse.data.results)) {
                showAlert({ type: 'info', message: getItemResponse.message });
                return;
            }

            if (getItemResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getItemResponse.data.length === 1) {
            this.setState({
                items: getItemResponse.data
            });
            await this.selectItemsEnter(getItemResponse.data);
        } else {
            this.setState({
                items: getItemResponse.data.results,
                pageTotal: getItemResponse.data.totalPage,
                mountItemCreateModal: true,
            });
            $('#itemsCreate').modal('show');
        }
    };


    //HEADER DOCUMENTO GENERAL
    renderDocumentHeader = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;

        let { permissions } = newOrderModel;

        let clientCardCode = 'Cliente:';
        let dateText = ' F. Entrega:';

        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'purchaseInvoice' || newOrderModel.OriginDocumentCreate === 'purchaseCreditNotes' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {
            dateText = 'F. Vencimiento:'
        }

        if (newOrderModel.OriginDocumentCreate === 'PurchaseOrder' || newOrderModel.OriginDocumentCreate === 'purchaseReturn'
            || newOrderModel.OriginDocumentCreate === 'transfersEntry' || newOrderModel.OriginDocumentCreate === 'transfersOutput'
            || newOrderModel.OriginDocumentCreate === 'GoodsReceipt' || newOrderModel.OriginDocumentCreate === 'purchaseInvoice'
            || newOrderModel.OriginDocumentCreate === 'purchaseCreditNotes') {
            clientCardCode = 'Proveedor:'
        }

        return (
            <div className="row">
                <div className="col-12 col-md-6">

                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{clientCardCode}</span>
                        </div>
                        <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                            style={{ backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                            disabled={action === 2 && !editMode ? true : false}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    this.openPartner();
                                }
                            }}
                            onChange={this.changeCardCode}
                            value={newOrderModel.CardCode ? newOrderModel.CardCode : ''} />
                        {action === 1 && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={this.openPartner}>
                                <i className="fas fa-user fa-lg" />
                            </button>
                        )}
                        {((newOrderModel.CardName !== '' && newOrderModel.partnerSelected) || (action === 2)) && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.openAccountBalance()}>
                                <i className="fas fa-info-circle"></i>
                            </button>)}
                    </div>
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                        />
                    </div>
                    {/*Persona de Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                        />
                        {(action === 1 || (action === 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Número de referencia:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">No. Referencia</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtCustomerRefNo"
                            disabled={action === 2 && !editMode ? true : false}
                            value={newOrderModel.NumAtCard ? newOrderModel.NumAtCard : ''}
                            onChange={this.changeNoReferencia}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.DocCur ? newOrderModel.DocCur : ''}
                        />
                        {(action === 1 || (action === 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openCurrency}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                        {/*<button type="button" style={{backgroundColor: "transparent", color: "#EABF28"}} className="btn"
                                onClick={this.openMonedaLocal}>
                            <i className="fa fa-list" aria-hidden="true"></i>
                        </button>*/}
                    </div>
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cambio</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.ChangeRate ? newOrderModel.ChangeRate : 1}
                        />
                    </div>
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action === 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Estado*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtStatus"
                            disabled="true"
                            value={newOrderModel.StatusDocument ? newOrderModel.StatusDocument : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type={action === 2 ? 'date' : 'date'}
                            disabled={action === 2 ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*Fecha de entrega:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{dateText}</span>
                        </div>
                        <input
                            id="txtDeliverDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type={action === 2 && !editMode ? 'date' : 'date'}
                            disabled={action === 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                            onChange={this.selectDocDueDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            type="date"
                            max='9999-12-31'
                            className="form-control"
                            id="txtStatus"
                            autoComplete="off"
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                        />
                    </div>
                </div>
            </div>
        );
    };

    //BODY DE CREACIÓN GENERAL
    renderDocumentBody = (item) => {
        const { newOrderModel, action, view, ShowBatchDefinitionModal } = this.props;
        const { editMode, _user } = this.state;
        let uuids = newOrderModel.U_FMB_UUID_RELACIONADO ? newOrderModel.U_FMB_UUID_RELACIONADO : [];
        let relacionSAT = newOrderModel.U_FMB_TIPO_RELACION ? newOrderModel.U_FMB_TIPO_RELACION : [];
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        let newOrderModelService = newOrderModel.service ? newOrderModel.service : [];
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        let itemsBatch = newOrderModelItems.filter((item) => item.ManBtchNum === 'Y');
        return (
            <div className="row">
                <div className="col-12 mb-3">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-Contenido-D"
                                data-toggle="tab"
                                href="#dataContenidoDocument"
                                role="tab"
                                aria-controls="dataContenidoDocument"
                                aria-selected="true">
                                Contenido
                            </a>
                            {(view !== 'PurchaseRequest' && view !== "suggestRefill") && <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-Finanzas"
                                data-toggle="tab"
                                href="#dataFinanzas"
                                role="tab"
                                aria-controls="dataFinanzas"
                                aria-selected="false">
                                Finanzas
                            </a>}
                            {(view !== 'PurchaseRequest' && view !== 'suggestRefill') && <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-logistica"
                                data-toggle="tab"
                                href="#dataLogistica"
                                role="tab"
                                aria-controls="dataLogistica"
                                aria-selected="false">
                                Logística
                            </a>}
                            {(view === 'debitNote' || view === 'invoiceReserve' || view === 'invoice' || view === 'invoiceAdvance' || view === 'creditNote' || view === 'payment') && <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-timbra"
                                data-toggle="tab"
                                href="#dataTimbra"
                                role="tab"
                                aria-controls="dataTimbra"
                                aria-selected="false">
                                Timbra-One
                            </a>}
                            {(view === 'citibanamex' && newOrderModel.U_FMB_Bank_Status === 'C') &&
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                    id="nav-profile-tab-concilia"
                                    data-toggle="tab"
                                    href="#dataConcilia"
                                    role="tab"
                                    aria-controls="dataConcilia"
                                    aria-selected="false">
                                    Concilia-One
                                </a>
                            }
                            {(view === 'invoice' || view === 'invoiceReserve' || view === 'invoiceAdvance' || view === 'creditNote') &&
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                    id="nav-profile-tab-XML"
                                    data-toggle="tab"
                                    href="#dataXML"
                                    role="tab"
                                    aria-controls="dataXML"
                                    aria-selected="false"
                                >
                                    Datos XML
                                </a>
                            }
                        </div>
                    </nav>
                    <div className="tab-content border border-top-0 rounded-bottom p-3">
                        {/* CONTENIDO */}
                        <div
                            className="w-100 table-scroll tab-pane fade"
                            id="dataContenidoDocument"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-Contenido"
                            style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}>

                            <table
                                id="dataTableDocuments"
                                className="display"
                                style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                                <thead className="table-header-yellow">
                                    <tr style={{ textAlign: "center" }}>
                                        <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            #
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Artículo
                                        </td>
                                        <td className="sticky-header" style={{ maxWidth: 800, backgroundColor: '#d2ab24' }}>
                                            Descripción
                                        </td>
                                        {/* {
                                        ((view ==='invoice' || view ==='creditNote' || view ==='debitNote' || view ==='orderSales' || view ==='deliveries' || view ==='invoiceAuthorization' || view === 'invoiceBorrador' || view ==='invoiceReserve') && (
                                        <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                            Unidad de Medida de I.
                                        </td>))
                                        } */}
                                        <td className="sticky-header" style={{/*maxWidth: 100,*/minWidth: 115, backgroundColor: '#d2ab24' }}>
                                            Almacén
                                        </td>
                                        {((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}>
                                                Disponible
                                            </td>))
                                        }
                                        {view === 'PurchaseRequest' &&
                                            <td className="sticky-header" style={{/*maxWidth: 100,*/minWidth: 170, backgroundColor: '#d2ab24' }}>
                                                Proveedor
                                            </td>}
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            {isSelectTo ? 'Cantidad Abierta' : view === 'invoiceBorrador' ? 'Cantidad original' : 'Cantidad'}
                                        </td>
                                        {/* {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Cantidad Cerrada
                                        </td>}
                                        {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Cantidad Original
                                        </td>} */}
                                        {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Cantidad Abierta
                                        </td>}
                                        {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Cantidad Entregada
                                        </td>}
                                        <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                            Precio
                                        </td>

                                        <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                            Costo artículo
                                        </td>

                                        <td className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}>
                                            %Desc
                                        </td>
                                        <th className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Descuento
                                        </th>
                                        {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Indicador I.
                                        </td>
                                        {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Código UMI
                                            </td>)
                                        }
                                        {(view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'purchaseReturn') && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Impuesto
                                        </td>} */}
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Total
                                        </td>
                                        {(view === 'purchaseInvoice') && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Proyecto
                                        </td>}
                                        {/*Orden de compra - Entrada de mercancia de proveedor*/}
                                        {/*PrecioXKilo*/}
                                        {(view === 'PurchaseOrder' || view === 'GoodsReceipt') &&
                                            <>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Kilos por comprar
                                                </td>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Pesos por pieza
                                                </td>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Precio por kilo
                                                </td>
                                            </>
                                        }

                                        {/* {view !== 'PurchaseRequest' &&
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 1
                                        </td>}
                                        {view !== 'PurchaseRequest' &&
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 2
                                        </td>}
                                        {view !== 'PurchaseRequest' &&
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 3
                                        </td>}
                                        {view !== 'PurchaseRequest' &&
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 4
                                        </td>} */}


                                        {/* CAMPOS DE USUARIO LINE */}
                                        {json.allItemsUserFields.map((field, index) => {
                                            if (field.enabled && field.name) {
                                                return (
                                                    <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                                        {field.name}
                                                    </td>
                                                );
                                            }
                                        })}
                                        {/* <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                            Cod. Norma Reparto C.C 5
                                            </td>
                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                Cuenta de Mayor
                                            </td>
                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                Cuenta Precio Coste
                                            </td>*/}
                                        {(view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && itemsBatch.length > 0 && (
                                            <td
                                                className="sticky-header sticky-columns"
                                                style={{ backgroundColor: '#d2ab24' }}
                                            >
                                                <i className="fa fa-th" aria-hidden="true" data-toggle="modal" data-target="#batchDefinitionModal" onClick={ShowBatchDefinitionModal}></i>
                                            </td>)
                                        }
                                    </tr>
                                </thead>

                                <tbody>
                                    {newOrderModelItems.map((item, index) => {
                                        return (
                                            <tr style={{ maxHeight: 10, paddingTop: 8, paddingBottom: 8, color: !item.stock ? 'red' : 'black', backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : (newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? '#FFD19B' : 'transparent' : 'transparent' }}
                                                title={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'Línea no existente en documento base' : '' : ''}
                                                data-toggle={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'tooltip' : '' : ''}
                                            >
                                                <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                                                    {index + 1}
                                                </td>
                                                {/*Artículos*/}
                                                <td className="overflow-visible"
                                                    style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                    {item.ItemCode}
                                                </td>

                                                {/*Descripción*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 800 }}>
                                                    {item.ItemName}
                                                </td>

                                                <td style={{ textAlign: 'center' }}>
                                                    <div className='input-group'>
                                                        {/*Almacen*/}
                                                        <input
                                                            type=" text"
                                                            placeholder="Almacén"
                                                            className=" form-control validarCant cantBlur btn-outline text-center"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            style={{
                                                                backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                                                color: '#000',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                                //maxWidth: 100,
                                                                // minWidth: 90
                                                            }}
                                                            onKeyPress={(eve) => {
                                                                if (eve.key === 'Enter') {
                                                                    this.openAlmacen(index, 1, item.ItemCode);
                                                                }
                                                            }}
                                                            value={item.WhsCode}
                                                            onChange={event => this.changeAlmacen(index, event)}
                                                        />
                                                        {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openAlmacen(index, 1, item.ItemCode)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                {/*U_Disponible*/}
                                                {
                                                    ((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                                                        <td>
                                                            <input
                                                                type=" text"
                                                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                disabled={true}
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                    // maxWidth: 100,
                                                                    minWidth: 80,
                                                                    textAlign: "center",
                                                                }}
                                                                value={Number.parseFloat(item.OnHand).toFixed(4) || 0}
                                                            />
                                                        </td>))
                                                }
                                                {view === 'PurchaseRequest' &&
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div className='input-group'>
                                                            {/*Proveedor*/}
                                                            <input
                                                                type=" text"
                                                                placeholder="Proveedor"
                                                                className=" form-control validarCant cantBlur btn-outline-secondary text-center"
                                                                disabled={action == 2 && !editMode ? true : false}
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                    minWidth: 90,
                                                                    borderColor: "#ced4da"
                                                                }}
                                                                onKeyPress={(eve) => {
                                                                    if (eve.key === 'Enter') {
                                                                        this.openPartner(index);
                                                                    }
                                                                }}
                                                                value={item.LineVendor}
                                                                onChange={event => this.ChangeLineVendor(index, event)}
                                                            />
                                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => this.openPartner(index)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                }
                                                <td>
                                                    <input
                                                        type="text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 100,
                                                            textAlign: "center",
                                                        }}
                                                        step="any"
                                                        id={'itemCantidad' + index}
                                                        value={item.Quantity}
                                                        onChange={event => this.changeQuantityItem(event, index)} />
                                                </td>

                                                {/* {isSelectTo && <td>
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            maxWidth: 60,
                                                            textAlign: "center",

                                                        }}
                                                        disabled={true}
                                                        id={'itemCantidad' + index}
                                                        value={item.BaseEntry ? item.OriginalQuantityClose : ''}
                                                    />
                                                </td>}

                                                {isSelectTo && <td>
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        disabled={true}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            maxWidth: 60,
                                                            textAlign: "center",

                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={item.BaseEntry ? Number.parseFloat(item.OriginalQuantity).toFixed(4) : ''}
                                                    />
                                                </td>} */}

                                                {/*PRECIO*/}
                                                {view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && <td style={{ width: 130 }}>
                                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                                        view === 'creditNote' ?
                                                            <>
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {/* <label
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                marginRight: '5px', // Espacio entre el label y el input
                                                                                textAlign: 'right',
                                                                            }}
                                                                        >
                                                                            {CURRENCY}
                                                                        </label> */}
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        className="form-control validarCant cantBlur btn-outline-secondary"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                            textAlign: 'right',
                                                                            minWidth: '16vh',
                                                                        }}
                                                                        id={'itemCantidad' + index}
                                                                        disabled={!(item?.InvntItem && item.InvntItem === 'N')}
                                                                        value={item.Price ?? '0.00'}
                                                                        onChange={event => this.changePriceInvntItem(event.nativeEvent.target.value, index, false)}
                                                                        onBlur={event => this.changePriceInvntItem(event.nativeEvent.target.value, index, true)}
                                                                    />
                                                                </div>
                                                            </>
                                                            :
                                                            <input
                                                                type="text"
                                                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                    width: 130,
                                                                    textAlign: 'right',
                                                                }}
                                                                id={'itemCantidad' + index}
                                                                disabled={true}
                                                                value={CURRENCY + " " + FORMAT_NUMBER.new(item.Price)}
                                                                onChange={event => this.changePriceItem(event, index)}
                                                                onBlur={event => this.validatePriceNull(index)}
                                                            />
                                                        :
                                                        <label
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                                width: 130,
                                                                textAlign: 'right',
                                                            }}>
                                                            {CURRENCY + " " + FORMAT_NUMBER.new(item.Price)}
                                                        </label>
                                                    }
                                                </td>}

                                                {/* Costo del artículo */}
                                                <td style={{ textAlign: 'right' }}>{CURRENCY + " " + FORMAT_NUMBER.new(item.AvgPrice)}</td>
                                                {/*%Descuento*/}
                                                <td>
                                                    <div className='input-group'>
                                                        <input
                                                            maxLength="5"
                                                            type="text"
                                                            disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editDiscountLine}
                                                            className=" form-control validar desBlur btn-outline-secondary"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                                widht: 50
                                                            }}
                                                            id={'iteDescuento' + index}
                                                            value={item?.DiscountPercent ?? '0.00'}
                                                            onChange={event => this.changeDiscountItem(event, index)}
                                                            onBlur={event => this.validateDiscountNull(index)}
                                                        />
                                                        <div className="input-group-append" >
                                                            <i className="fa fa-info-circle"
                                                                title={`${_user?.U_Discount || 0}%`}
                                                                data-toggle="tooltip"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    marginLeft: 5,
                                                                    marginTop: 10,
                                                                }}
                                                                aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                </td>
                                                {/*%Descuento*/}
                                                <td style={{ textAlign: 'right' }}>{CURRENCY + " " + FORMAT_NUMBER.new(item?.Discount ?? '0')}</td>
                                                {/*Indicador*/}
                                                {/* <td style={{ textAlign: 'center' }}>

                                                    {item.TaxCode}
                                                    {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) &&
                                                        !this.isMarketingDocument(view) &&
                                                        (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.openTaxes(index)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        )}
                                                </td> */}

                                                {/*Código UMI*/}
                                                {/* {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') && (
                                                    <td style={{ textAlign: 'center' }}>
                                                        {item.SalUnitMsr || ''}
                                                    </td>)
                                                }
                                                {(view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                                                    <td style={{ textAlign: 'center' }}>
                                                        {item.BuyUnitMsr || ''}
                                                    </td>)
                                                } */}

                                                {/*Impuesto*/}
                                                {/* {(view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'purchaseReturn') &&
                                                    <td style={{ textAlign: 'right' }}>{newOrderModel.DocCur + " " + FORMAT_NUMBER.new(item.TaxeResult)}</td>} */}
                                                {/*Total*/}
                                                <td style={{ textAlign: 'right' }}>{newOrderModel.DocCur + " " + FORMAT_NUMBER.new(item.Total)}</td>
                                                {(view === 'purchaseInvoice') && <td>
                                                    {/*No de Proyecto*/}
                                                    {item.Project}
                                                    {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.openProjects(index)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    )}
                                                </td>}

                                                {/*Orden de compra - Entrada de mercancia de proveedor*/}
                                                {(view === 'PurchaseOrder' || view === 'GoodsReceipt') &&
                                                    <>
                                                        {/*KilosXComprar*/}
                                                        <td style={{ width: 130 }}>
                                                            {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                                                <input
                                                                    type="text"
                                                                    className="form-control validarCant cantBlur btn-outline-secondary"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                        paddingTop: 1,
                                                                        paddingBottom: 2,
                                                                        width: 130,
                                                                        textAlign: 'right',
                                                                    }}
                                                                    id={'KilosXComprar' + index}
                                                                    value={item.KilosXComprar ?? 0}
                                                                    onChange={event => this.changeKilosXComprar(event, index)}
                                                                    onBlur={() => this.validateKilosXComprar(index)}
                                                                /> :
                                                                <label>{item.KilosXComprar ? parseFloat(item.KilosXComprar).toFixed(3) : "0"} KG</label>
                                                            }
                                                        </td>

                                                        {/*PesosXPieza*/}
                                                        <td style={{ width: 130 }}>
                                                            {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                                                <input
                                                                    type="text"
                                                                    className="form-control validarCant cantBlur btn-outline-secondary"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                        paddingTop: 1,
                                                                        paddingBottom: 2,
                                                                        width: 130,
                                                                        textAlign: 'right',
                                                                    }}
                                                                    id={'PesosXPieza' + index}
                                                                    value={item.PesosXPieza ?? 0}
                                                                    onChange={event => this.changePesosXPieza(event, index)}
                                                                    onBlur={() => this.validatePesosXPieza(index)}
                                                                /> :
                                                                <label>{FORMAT_NUMBER.new(item.PesosXPieza ?? '0')}</label>
                                                            }
                                                        </td>

                                                        {/*PrecioXKilo*/}
                                                        <td style={{ width: 130 }}>
                                                            {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                                                <input
                                                                    type="text"
                                                                    className="form-control validarCant cantBlur btn-outline-secondary"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                        paddingTop: 1,
                                                                        paddingBottom: 2,
                                                                        width: 130,
                                                                        textAlign: 'right',
                                                                    }}
                                                                    id={'PrecioXKilo' + index}
                                                                    value={item.PrecioXKilo ?? 0}
                                                                    onChange={event => this.changePrecioXKilo(event, index)}
                                                                    onBlur={() => this.validatePrecioXKilo(index)}
                                                                /> :
                                                                <label>{CURRENCY + FORMAT_NUMBER.new(item.PrecioXKilo ?? '0')}</label>
                                                            }
                                                        </td>
                                                    </>}




                                                <td
                                                    className="sticky-columns"
                                                    style={{
                                                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                        textAlign: 'center'
                                                    }}>
                                                    {/*Eliminar*/}
                                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.deleteItem(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>

                                            </tr>
                                        );
                                    })}

                                    <tr>
                                        <td></td>
                                        <td className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>


                                            {(action === 1 || (action === 2 && editMode && permissions.editItems)) && (

                                                <div>
                                                    <input
                                                        type=" text"
                                                        placeholder="Artículo"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                        }}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.openItems();
                                                            }
                                                        }}
                                                        value={newOrderModel.searchItem || ''}
                                                        onChange={event => this.changeSearchItem(event)}
                                                    // onBlur={event => this.specialPrice(index)}
                                                    />
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openItems()}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        {/* FRINANZAS */}
                        <div
                            className="tab-pane fade col-12 col-md-6"
                            id="dataFinanzas"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-Fianazas">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Condición Pago</span>
                                </div>
                                <input
                                    type=" text"
                                    className="form-control btn-outline-secondary"
                                    disabled={true}
                                    style={{ widht: '50%', backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.GroupName ? newOrderModel.GroupName : ''}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Forma Pago</span>
                                </div>
                                <input
                                    type=" text"
                                    className="form-control"
                                    disabled={true}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.PymName ? newOrderModel.PymName : ''}
                                />
                            </div>
                            <div>
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Autorización</span>
                                    <input
                                        type="checkbox"
                                        disabled={true}
                                        onChange={() => this.ChangeConfirmed()}
                                        style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                        checked={newOrderModel.Confirmed}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Permitir entrega parcial</span>

                                    <input
                                        type="checkbox"
                                        disabled={true}
                                        onChange={() => this.ChangePartSupply()}
                                        style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                        checked={newOrderModel.PartSupply}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* LOGISTICA */}
                        <div
                            style={{ paddingTop: 5 }}
                            className="tab-pane fade col-12 col-md-6"
                            id="dataLogistica"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-Logistica">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Destino</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                />
                                {(action === 1 || (action === 2 && editMode && permissions.editItems)) && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => this.openAddresses(1)}>
                                        <i className="fas fa-list" />
                                    </button>
                                )}
                            </div>

                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.Address2 ? newOrderModel.Address2 : ''}
                                />
                            </div>


                        </div>
                        {/* TIMBRA-ONE */}
                        <div
                            style={{ paddingTop: 5 }}
                            className="tab-pane fade"
                            id="dataTimbra"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-timbra">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">Tipo relación CFDI</span>
                                                <span className="d-inline d-xl-none">Tipo rel. CFDI</span>
                                            </span>
                                        </div>
                                        <select
                                            className="form-control input-sm"
                                            id="txtRELACION_SAT"

                                            disabled={action === 2 && !editMode && permissions.editEmployee}
                                            value={newOrderModel.U_FMB_TIPO_REL}
                                            onChange={(event) => { this.ChangeU_FMB_TIPO_REL(event.target.value) }}>
                                            {relacionSAT.map((opcion) => {
                                                return (
                                                    <option value={opcion.FldValue}>{opcion.Descr}</option>
                                                )

                                            })}
                                        </select>
                                        <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                            {(action === 1 || (action === 2 && !editMode && permissions.editEmployee)) && <button
                                                type="button"
                                                className="btn"
                                                style={{ padding: 4 }}
                                                onClick={() => this.AddUuid()} >
                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10"></i>
                                            </button>}
                                        </div>
                                    </div>

                                    {!!uuids && uuids.map((uuid, index) => {
                                        return (
                                            <div
                                                id={`uuidRel${index}`}
                                                className="input-group mb-3" >
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">UUID Relacionado {index + 1}</span>
                                                        <span className="d-inline d-xl-none">UUID Rel. {index + 1}</span>
                                                    </span>
                                                </div>
                                                <input
                                                    type="text"
                                                    maxLength="36"
                                                    style={{ textAlign: 'left' }}
                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                    className="form-control input-sm"
                                                    value={uuid}
                                                    onChange={(e) => this.HandleChange(e, index)} />
                                                <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                                    {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && <button
                                                        type="button"
                                                        className="btn"
                                                        style={{ padding: 4 }}
                                                        onClick={() => this.RemoveUuid(index)} >
                                                        <i className="fa fa-minus-circle" aria-hidden="true" size="10"></i>
                                                    </button>}

                                                </div>
                                            </div>
                                        )
                                    })
                                    }

                                    {newOrderModel.U_UDF_UUID && <div >
                                        <div>
                                            <label className="btn float-left" onClick={() => this.DownloadDoc('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF</label>
                                            <label className="btn float-left" onClick={() => this.DownloadDoc('XML')}><i className="fa fa-file-text"></i> Descargar XML</label>
                                        </div>
                                    </div>}

                                    {newOrderModel.U_FMB_FOLIO_PORTE && <div >
                                        <div>
                                            <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte</label>
                                            <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i className="fa fa-file-text"></i> Descargar XML Carta Porte</label>
                                        </div>
                                    </div>}

                                    {newOrderModel.IsCancelCFDI === 'Y' && <div >
                                        <div>
                                            <label className="btn float-left" onClick={() => this.DownloadDocCancel('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF de solicitud de Cancelación</label>
                                            <label className="btn float-left" onClick={() => this.DownloadDocCancel('XML')}><i className="fa fa-file-text"></i> Descargar XML de solicitud de Cancelación</label>
                                        </div>
                                    </div>}

                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">UUID</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtUDF_UUID"
                                            disabled="true"
                                            value={newOrderModel.U_UDF_UUID || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Sello digital</span>
                                                <span className="d-inline d-xl-none">Sello dig.</span>
                                            </span>
                                        </div>
                                        <textarea
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_SELLO"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_SELLO || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Folio digital</span>
                                                <span className="d-inline d-xl-none">Folio dig.</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_FOLIO"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_FOLIO || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Serie digital</span>
                                                <span className="d-inline d-xl-none">Serie dig.</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_SERIE"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_SERIE || ''}
                                        />
                                    </div>
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">UUID Relacionado</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_UUID_ASOCIADO"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_UUID_RELACIONADO || ''}
                                        />
                                    </div> */}

                                </div>
                            </div>
                        </div>
                        {/* CONCILIA-ONE */}
                        <div
                            style={{ paddingTop: 5 }}
                            className="tab-pane fade"
                            id="dataConcilia"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-timbra">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Numero de cuenta</span>
                                        </div>
                                        <label className="form-control">{newOrderModel.TransferAccount || ""}</label>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Fecha de la transferencia</span>
                                        </div>
                                        <label className="form-control">{newOrderModel.TransferDate || ""}</label>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Concepto</span>
                                        </div>
                                        <label className="form-control">{newOrderModel.TransferConcept || ""}</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Referencia</span>
                                        </div>
                                        <label className="form-control">{newOrderModel.TransferReference || ""}</label>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Importe</span>
                                        </div>
                                        <label className="form-control text-right">{newOrderModel.TransferTotal || "0.00"}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* DATOS XML*/}
                        <div style={{ paddingTop: 5 }} className="tab-pane fade" id="dataXML" role="tabpanel" aria-labelledby="nav-home-tab-XML">
                            <DataXML
                                newOrderModel={newOrderModel}
                                enableSpinner={this.props.enableSpinner}
                                showAlert={this.props.showAlert}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    //FOOTER DE CREACIÓN GENERAL
    renderDocumentFooter = () => {
        const { view, newOrderModel, action } = this.props;
        const { editMode } = this.state;
        let { permissions } = newOrderModel;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Empleado de ventas:*/}
                    {view !== 'PurchaseRequest' && view !== 'suggestRefill' &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Empleado ventas</span>
                                    <span className="d-inline d-xl-none">Empleado</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtSlpName"
                                disabled="true"
                                value={newOrderModel.SlpName ? newOrderModel.SlpName : ''}
                            />
                            {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openEmployee}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>}
                    {/*Nombre del Propietario*/}
                    {view !== 'suggestRefill' &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Propietario</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtDocumentsOwnerName"
                                disabled="true"
                                value={newOrderModel.OwnerName ? newOrderModel.OwnerName : ''}
                            />
                            {false && (action === 1 || (action === 2 && editMode && permissions.editOwner)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openPropietario}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>

                    }

                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action === 2 && !editMode ? true : false}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                    {/*Nombre del Etapa autorización*/}
                    {((view === 'invoiceAuthorization') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Modelo de autorización</span>
                                    <span className="d-inline d-xl-none">Mod. autorización</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtDocumentsOwnerName"
                                disabled="true"
                                value={newOrderModel.WtmName ? newOrderModel.WtmName : ''}
                            />
                            {(action === 1 || (action === 2 && editMode && permissions.editOwner)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openPropietario}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>))}
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*Total antes del Descuento*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Total antes Dcto:{' '}</span>
                                <span className="d-inline d-xl-none">Antes Dcto:</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtSubTotalS"
                            disabled="true"
                            value={
                                ((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + FORMAT_NUMBER.new(newOrderModel.Subtotal ? newOrderModel.Subtotal : '')
                                )
                            }
                        />
                    </div>
                    {/*Descuento:*/}
                    {view !== 'PurchaseRequest' &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Descuento</span>
                            </div>
                            <input
                                style={{
                                    width: '20%',
                                    textAlign: 'right',
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                }}
                                type="text"
                                className="form-control"
                                id="txtDiscPrcnt"
                                disabled={true}
                                onChange={event => this.changeDiscountDocument(event)}
                                onBlur={this.validateDiscountDocumentNull}
                                value={newOrderModel.DiscountPercent || ''}
                            />
                            <input
                                style={{ textAlign: 'right' }}
                                type="text"
                                className="form-control"
                                id="txtDiscPrcntt"
                                value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + FORMAT_NUMBER.new(newOrderModel.Discount ? newOrderModel.Discount : '')
                                )
                                }
                                disabled="true"
                            />
                        </div>}

                    {/*Impuesto*/}
                    {newOrderModel.DpmAmnt > 0 && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Anticipo total</span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtDpmAmnts"
                            disabled="true"
                            value={
                                ((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + FORMAT_NUMBER.new(newOrderModel.DpmAmnt)
                                )
                            }
                        />
                    </div>}
                    {/*Impuesto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Impuesto</span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtVatSumS"
                            disabled="true"
                            value={
                                ((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + FORMAT_NUMBER.new(newOrderModel.Taxes ? newOrderModel.Taxes : '')
                                )
                            }
                        />
                    </div>

                    {/*Total del documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Total documento</span>
                                <span className="d-inline d-xl-none">Total</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtDocTotalS"
                            disabled="true"
                            value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                + FORMAT_NUMBER.new(newOrderModel.Total ? newOrderModel.Total : '')
                            )
                            }
                        />
                    </div>

                </div>
            </div>
        );
    };

    // HEADER DE CREACION DE TRASLADO
    renderDocumentTransfersHeader = () => {
        const { newOrderModel, action, view, prices } = this.props;
        const { editMode } = this.state;
        // Al crear nuevo documento trae cero y no existe en el mapeo (Default -1 Ult precio de compra en SAP)
        newOrderModel.GroupNum = newOrderModel.GroupNum === 0 ? -1 : newOrderModel.GroupNum;
        return (
            <div className="row">
                {/*Priemra columna*/}
                <div className="col-12 col-md-6">
                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtPartner"
                            style={{ backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent' }}
                            disabled={action === 2}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    this.openPartner();
                                }
                            }}
                            onChange={this.changeCardCode}
                            value={newOrderModel.CardCode ? newOrderModel.CardCode : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPartner}>
                                <i className="fas fa-user" />
                            </button>
                        )}
                    </div>
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                        />
                    </div>
                    {/*Persona de Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                        />
                        {(action == 1 || (action == 2)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Address:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control btn-outline-secondary"
                            id="txtCustomerRefNo"
                            disabled="true"
                            value={newOrderModel.Address ? newOrderModel.Address : ''}
                            onChange={this.changeAddress}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>

                    {((view === 'transfers') && (action === 1)) &&
                        <>
                            {/* Almacén de transito */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                        <span className="d-none d-xl-inline">Tipo de Traslado</span>
                                        <span className="d-inline d-xl-none">T. Traslado</span>
                                    </span>
                                </div>
                                <select className="form-control"
                                    onChange={event => this.changeAlmacenTransito(event)}
                                    disabled={view === 'transfersRequest' ? true : false}
                                    value={newOrderModel?.Transit ?? ""} >
                                    <option value="1">Sucursal a Sucursal</option>
                                    <option value="2">Recepción de CEDIS</option>
                                    <option value=""> Traspaso directo</option>
                                    {/* <option value="3">Sucursal a CEDIS</option> */}
                                </select>
                            </div>

                            {view === 'transfers' &&
                                <>
                                    {/*NUMERO DE DOCUMENTO PARA REVERSA:*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">No. Doc Recuperar</span>
                                                <span className="d-inline d-xl-none">No. Doc</span>
                                            </span>
                                        </div>
                                        <input type=" text" placeholder="Documentos pendientes CEDIS" className="form-control "
                                            disabled={true}
                                            onKeyDown={(eve) => {
                                                if (eve.key === 'Enter') { this.OpenTransfers() }
                                            }}
                                            value={newOrderModel?.DocNumCEDIS ?? ''}
                                            onChange={event => this.ChangeDocNumCEDIS(event.target.value)}
                                        />

                                        <button type="button"
                                            className="input-group-text"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onClick={() => this.OpenTransfers()}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>

                                    </div>

                                    {/*>almacen de entrada CEDIS*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Almacén de entrada</span>
                                                <span className="d-inline d-xl-none">Alm. entrada</span>
                                            </span>
                                        </div>
                                        <input
                                            type=" text"
                                            placeholder="Almacén Recepcion CEDIS"
                                            className="form-control "
                                            // style={{ backgroundColor: 'transparent', color: '#000', paddingTop: 1, paddingBottom: 2, maxWidth: 800 }}
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onKeyPress={(eve) => {
                                                if (eve.key === 'Enter') {
                                                    this.openAlmacen(null, 117);
                                                }
                                            }}
                                            value={newOrderModel.WarehouseCEDIS ?? ''}
                                            onChange={event => this.ChangeAlmacenRecepCEDIS(event)}
                                        />

                                        <button type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2 }}
                                            className="input-group-text"
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onClick={() => this.openAlmacen(null, 117)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                    }
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">F. Contabilización</span>
                                <span className="d-inline d-xl-none">F. Contab.</span>
                            </span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}

                            disabled={action == 2}
                            className=" form-control"
                            id="txtStatus"
                            max='9999-12-31'
                            autoComplete="off"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                            onChange={this.selectDocDueDate}
                        />
                    </div>
                    {/*>almacen origen:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">De Almacén</span>
                        </div>
                        <input
                            type="text"
                            placeholder="Almacén origen"
                            className="form-control"
                            disabled
                            onKeyPress={({ key }) => { if (key === 'Enter') { this.openAlmacen(null, 2); } }}
                            value={newOrderModel.Filler ? newOrderModel.Filler : ''}
                        // onChange={event => this.changeAlmacenOrigen(event)} // Isra pidio que el almacen de origen no se pueda cambiar
                        />
                        {(action === 1 && (!newOrderModel.Filler || newOrderModel.Filler === "") && (Number(newOrderModel?.Transit || 0) !== 2)) && (<button type="button" // Solo mostrar si no se detecto el almacen de origen
                            style={{
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                paddingTop: 2,
                                paddingBottom: 2,
                            }}
                            className="input-group-text"
                            onClick={() => this.openAlmacen(null, 2)}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                        )}
                    </div>
                    {/*>almacen Finall opcional:*/}
                    {/* {action == 1 && <div className="form-group row" id="div1">
                        <label htmlFor="txtDocumentDate" className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                            Almacén Tránsito:
                        </label>
                        <div className="col-md-6 col-sm-12">
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtStatus"
                                disabled="true"
                                value={newOrderModel.wareHouseFinalOptionalValue ? newOrderModel.wareHouseFinalOptionalValue : ''}
                            />
                        </div>
                        {action == 1 && (
                            <button
                                type="button"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#EABF28',
                                }}
                                className="btn "
                                onClick={() => this.openAlmacen(null, 4)}>
                                <i className="fa fa-list" aria-hidden="true"/>
                            </button>
                        )}
                    </div>} */}
                    {/*>almacen destino:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Almacén Destino</span>
                                <span className="d-inline d-xl-none">Alm. Destino</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            placeholder="Almacén destino"
                            className="form-control"
                            // disabled={(action === 2 && !editMode) || (Number(newOrderModel?.Transit || 0) === 2)}
                            disabled
                            onKeyPress={(eve) => {
                                if (eve.key === 'Enter') {
                                    this.openAlmacen(null, 3);
                                }
                            }}
                            value={newOrderModel.ToWhsCode ? newOrderModel.ToWhsCode : ''}
                        // onChange={event => this.changeAlmacenDestino(event)}
                        />
                        {(action === 1 && (Number(newOrderModel?.Transit || 0) !== 2)) && newOrderModel.U_FMB_WHS_TYPE !== '7' && (<button type="button"
                            style={{
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                paddingTop: 2,
                                paddingBottom: 2,
                            }}
                            className="input-group-text"
                            onClick={() => this.openAlmacen(null, 3)}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                        )}
                    </div>

                    {/* Lista de Precios: */}
                    {((view === 'transfers' || view === 'transfersRequest')) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Lista De Precios</span>
                                    <span className="d-inline d-xl-none">Lista Precios</span>
                                </span>
                            </div>
                            <select className="form-control" disabled={(action === 2 && !editMode) ? true : false}
                                onChange={action === 1 ? (event) => this.changeSelectedFieldDocument(event) : ''}
                                value={newOrderModel.GroupNum || -1} >

                                {prices.map(price => {
                                    return (
                                        <option value={price.ListNum}>{price.ListName}</option>
                                    )
                                })}
                                <option value={-1}>Último precio de compra</option>
                                <option value={-2}>Último precio determinado</option>
                            </select>
                        </div>)}
                </div>
            </div>
        );
    };

    //BODY DE CREACIÓN DE TRASLADO
    renderDocumentTransfersBody = () => {
        const { newOrderModel, action, view } = this.props;
        const { editMode } = this.state;
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        return (
            <div className="row">
                <div className="col-12 mb-3">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <a
                                className="nav-item nav-link font-weight-bold text-secondary active"
                                id="nav-profile-tab-Contenido-T"
                                data-toggle="tab"
                                href="#dataContenido2"
                                role="tab"
                                aria-controls="dataContenido"
                                aria-selected="true">
                                Contenido
                            </a>
                            {view === 'transfers' &&
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-profile-tab-timbra"
                                    data-toggle="tab"
                                    href="#dataTimbra"
                                    role="tab"
                                    aria-controls="dataTimbra"
                                    aria-selected="false">
                                    Timbra-One
                                </a>}
                            {/*<a className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Finanzas" data-toggle="tab" href="#dataFinanzas"
                            role="tabFin" aria-controls="dataFinanzas"
                            aria-selected="false">Finanzas</a>*/}
                        </div>
                    </nav>

                    <div className="tab-content border border-top-0 rounded-bottom p-3" style={{ textAlign: 'left' }}>
                        <div
                            className="w-100 table-scroll tab-pane fade show active"
                            id="dataContenido2"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-Contenido"
                            style={{ maxHeight: 500 }}>
                            <table
                                id="dataTableDocuments"
                                className="display"
                                style={{ width: '100%', marginBottom: 40, marginRight: -2000 }}>
                                <thead className="table-header-yellow">
                                    <tr>
                                        <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Artículo
                                        </td>
                                        <td className="sticky-header" style={{ maxWidth: 200, textAlign: 'center', backgroundColor: '#d2ab24' }}>
                                            Descripción
                                        </td>
                                        {(view === 'transfersRequest' || view === 'transfers') && (
                                            <td className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}>
                                                Almacén
                                            </td>)
                                        }
                                        {(view === 'transfersRequest' || view === 'transfers') && (
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}>
                                                {(action === 2) ? "STOCK ALMACÉN ORIGEN" : "STOCK EN ALMACÉN"}
                                            </td>)
                                        }
                                        {(view === 'transfersRequest' || view === 'transfers') && (
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}>
                                                {(action === 2) ? "STOCK ALMACÉN DESTINO" : "STOCK EN GENERAL"}
                                            </td>)
                                        }

                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', maxWidth: 80 }}>
                                            Cantidad
                                        </td>

                                        {(view === 'suggestRefill') && (
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24', maxWidth: 80 }}>
                                                Cesion uso
                                            </td>)
                                        }

                                        {(action == 2 || (action == 1 && view === 'transfersRequest') || (action == 1 && view === 'transfers')) && (<td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Precio
                                        </td>)}
                                        {(view === 'transfersRequest' || view === 'transfers') && (
                                            <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                                Costo artículo
                                            </td>)
                                        }
                                        {(view === 'transfersRequest' || view === 'transfers') && (
                                            <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                                Código UMI
                                            </td>)
                                        }
                                        {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 1
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 2
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 3
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Centro 4
                                        </td> */}
                                        {/* 
                                    <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                        Total
                                    </td> */}
                                        <td
                                            className="sticky-header sticky-columns"
                                            style={{ backgroundColor: '#d2ab24' }}
                                        />
                                    </tr>
                                </thead>
                                <tbody>
                                    {newOrderModelItems.map((item, index) => {
                                        let itemStock = item?.wareHouseStock?.find(whs => whs.WhsCode === newOrderModel?.Filler);
                                        return (
                                            <tr style={{ color: item.stock ? 'black' : 'red' }}>
                                                <td className="sticky-column" style={{ backgroundColor: '#FFF' }}>
                                                    {item.ItemCode}
                                                </td>
                                                {/*Artículos*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {item.ItemName}
                                                </td>
                                                {/*Almacen*/}
                                                {(view === 'transfersRequest' || view === 'transfers') && (
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div className='input-group'>
                                                            {/* {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && ( */}
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openAlmacen(index, 5, item.ItemCode)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                            {/* )} */}
                                                        </div>
                                                    </td>)
                                                }
                                                {/*Disponible*/}
                                                {(view === 'transfersRequest' || view === 'transfers') && (
                                                    <td style={{ textAlign: 'right' }}>
                                                        {Number(itemStock?.OnHand ?? '0').toFixed(4)}
                                                    </td>)
                                                }
                                                {/*Stock en general*/}
                                                {(view === 'transfersRequest' || view === 'transfers') && (
                                                    <td style={{ textAlign: 'right' }}>
                                                        {Number(item.OnHand).toFixed(4) || 0}
                                                    </td>)
                                                }
                                                {/*Descripción*/}
                                                {/*<td style={{textAlign: 'center'}}>
                                                {item.Filler}
                                                {action == 5 && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openAlmacen(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true"/>
                                                    </button>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}}>
                                                {item.ToWhsCode}
                                                {action == 5 && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openAlmacen(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true"/>
                                                    </button>
                                                )}
                                            </td>*/}
                                                {!newOrderModel?.CEDIS_Reception ?
                                                    <td>
                                                        <input
                                                            type=" text"
                                                            // style={{ maxWidth: 60 }}
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            disabled={action == 2 ? true : false}
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                                maxWidth: 80
                                                            }}
                                                            id={'itemCantidad' + index}
                                                            value={item.Quantity}
                                                            onChange={event => this.changeQuantityItem(event, index)}
                                                        // onBlur={event => this.specialPrice(index)}
                                                        />
                                                    </td>
                                                    :
                                                    <td
                                                        className="overflow-visible"
                                                        style={{ textAlign: 'center', maxWidth: 200 }}>
                                                        {item.Quantity}
                                                    </td>
                                                }

                                                {(view === 'suggestRefill') && (
                                                    <td
                                                        className="overflow-visible"
                                                        style={{ textAlign: 'center', maxWidth: 200 }}>
                                                        {item.MovimientoDiario || 0}
                                                    </td>)
                                                }
                                                {/*Precio*/}
                                                {!newOrderModel?.CEDIS_Reception ?
                                                    (action === 2 || (action === 1 && view === 'transfersRequest') || (action === 1 && view === 'transfers')) && (<td style={{ width: 130 }}>
                                                        <input
                                                            type=" text"
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            //disabled={(action == 2 ) ? true : !permissions.editItems}
                                                            disabled={true}
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: Number(item.Price) === 0 ? 'red' : '#000',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                                width: 130,
                                                                textAlign: 'right',
                                                            }}
                                                            id={'itemCantidad' + index}
                                                            value={CURRENCY + FORMAT_NUMBER.new(item.Price)}
                                                            onChange={event => this.changePriceItem(event, index)}
                                                            onBlur={event => this.validatePriceNull(index)}
                                                        />
                                                    </td>)
                                                    :
                                                    <td
                                                        className="overflow-visible"
                                                        style={{ textAlign: 'center', width: 130, maxWidth: 200 }}>
                                                        {CURRENCY + FORMAT_NUMBER.new(item.Price)}
                                                    </td>
                                                }
                                                {/* Costo del artículo */}
                                                {(view === 'transfersRequest' || view === 'transfers') && (
                                                    <td style={{ textAlign: 'right' }}>
                                                        {CURRENCY + " " + FORMAT_NUMBER.new(item.AvgPrice)}
                                                    </td>)
                                                }
                                                {/*Código UMI*/}
                                                {(view === 'transfersRequest' || view === 'transfers') && (
                                                    <td style={{ textAlign: 'center' }}>
                                                        {item.InvntryUom || ''}
                                                    </td>)
                                                }


                                                <td
                                                    className="sticky-columns"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>


                                                    {action === 1 && !newOrderModel?.CEDIS_Reception && (

                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.deleteItem(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>
                                                {' '}

                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* TIMBRA-ONE */}
                        <div
                            style={{ paddingTop: 5 }}
                            className="tab-pane fade"
                            id="dataTimbra"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-timbra">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    {newOrderModel.U_UDF_UUID && <div >
                                        <div>
                                            <label className="btn float-left" onClick={() => this.DownloadDoc('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF</label>
                                            <label className="btn float-left" onClick={() => this.DownloadDoc('XML')}><i className="fa fa-file-text"></i> Descargar XML</label>
                                        </div>
                                    </div>}

                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">UUID</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtUDF_UUID"
                                            disabled="true"
                                            value={newOrderModel.U_UDF_UUID || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Sello digital</span>
                                                <span className="d-inline d-xl-none">Sello dig.</span>
                                            </span>
                                        </div>
                                        <textarea
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_SELLO"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_SELLO || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Folio digital</span>
                                                <span className="d-inline d-xl-none">Folio dig.</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_FOLIO"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_FOLIO || ''}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Serie digital</span>
                                                <span className="d-inline d-xl-none">Serie dig.</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtFMB_SERIE"
                                            disabled="true"
                                            value={newOrderModel.U_FMB_SERIE || ''}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    };
    //FOOTER DE CREACIÓN DE TRASLADO
    renderTransfersFooter = () => {
        const { newOrderModel, action, view } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Empleado de ventas:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Empleado ventas</span>
                                <span className="d-inline d-xl-none">Empleado</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtSlpName"
                            disabled="true"
                            value={newOrderModel.SlpName ? newOrderModel.SlpName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openEmployee}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="50 caracteres máximo"
                            maxLength={51}
                            disabled={action == 2}
                            value={newOrderModel.JrnlMemo ? newOrderModel.JrnlMemo : ''}
                            onChange={this.changeCommentsMemo}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*Comentarios:*/}

                    {(view == 'transfersRequest' || newOrderModel.ObjType == '1250000001') && false &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Obs. de Empaque</span>
                            </div>
                            <input
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                //maxLength={10}
                                //----------------
                                disabled={action == 2}
                                value={newOrderModel.PickRmrk ? newOrderModel.PickRmrk : ''}
                                onChange={this.changePickMmrk}
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            />
                        </div>}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action == 2}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    //HEADER DE CREACIÓN GENERAL
    renderDocumentHeaderPurchaseRequest = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;

        let { permissions } = newOrderModel;

        let clientCardCode = 'Solicitante:';

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{clientCardCode}</span>
                        </div>
                        <select
                            className="form-control"
                            id='selectTypePurchaseRequest'
                            onChange={this.changeReqType}
                            disabled={action === 2 && !editMode ? true : (permissions ? !permissions.editItems : false)}
                            value={newOrderModel.ReqType ? newOrderModel.ReqType : ''}>
                            <option value="12">Usuario</option>
                            <option value="171">Empleado</option>
                        </select>
                    </div>
                    {/*CODIGO del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.Requester ? newOrderModel.Requester : ''}
                        />
                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonRequest}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Nombre del solicitangte*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Nombre de solicitante</span>
                                <span className="d-inline d-xl-none">Solicitante</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.ReqName ? newOrderModel.ReqName : ''}
                        />
                    </div>
                    {/*Sucursal*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.BranchName ? newOrderModel.BranchName : ''}
                        />
                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openBranches}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Departament*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Departamento</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.DepartmentName ? newOrderModel.DepartmentName : ''}
                        />
                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openDepartment}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Active*/}
                    <div className="input-group mb-3" style={{ height: 60 }}>
                        <label htmlFor="txtContactPerson"
                            className="col-md-12 col-sm-12 col-form-label font-weight-bold" style={{ marginTop: '-10px' }}> <input
                                type="checkbox"
                                disabled={(action === 2 && !editMode) ? true : (permissions ? !permissions.editItems : false)}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000'
                                }}
                                id="cbox1"
                                checked={newOrderModel.Notify === 'Y' ? true : false}
                                onChange={this.changeActiveSendEmail} /> Enviar correo electrónico si se agrega un pedido, o un pedido de entrada de mercancías:
                        </label>
                    </div>

                    {/*Correo */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correo</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editItems : false)}
                            value={newOrderModel.Email ? newOrderModel.Email : ''}
                            onChange={this.changeEmail}
                        />
                    </div>

                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Estado*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtStatus"
                            disabled="true"
                            value={newOrderModel.StatusDocument ? newOrderModel.StatusDocument : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">F. Contabilización</span>
                                <span className="d-inline d-xl-none">F. Contab.</span>
                            </span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*Fecha de entrega:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Válido Hasta</span>
                        </div>
                        <input
                            id="txtDeliverDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 && !editMode ? 'date' : 'date'}
                            disabled={action == 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                            onChange={this.selectDocDueDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            className=" form-control"
                            id="txtStatus"
                            autoComplete="off"
                            max='9999-12-31'
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Necesaria</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.ReqDate ? newOrderModel.ReqDate : ''}
                            onChange={this.selectReqDate}

                        />
                    </div>
                </div>
            </div>
        );

    };

    renderTitleModal = () => {
        const { action, newOrderModel } = this.props;
        let complemento = "";
        let authorized = newOrderModel.isDocumentWithAuthorization;

        if (authorized) {
            complemento = "[Autorizado]";
        }

        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {

            case 'suggestRefill':
                title = 'Sugerido de resurtido';
                break;
            case 'transfersRequest':
                title = 'Solicitud de Traslado ' + complemento;
                break;
            case 'PurchaseRequest':
                title = 'Solicitud de Compra  ' + complemento;
                break;

            default:
        }

        if (action === 1) {
            title = 'Nuevo(a) ' + title;
        }

        if (action === 2) {
            title = 'Detalle de ' + title;
        }

        return title;
    };

    TitleModal = () => {
        const { view, action, newOrderModel } = this.props;

        let complemento = "";

        let authorized = newOrderModel.isDocumentWithAuthorization;

        if (authorized) {
            complemento = "";
        }

        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {

            case 'transfersRequest':
                title = 'Solicitud de Traslado ' + complemento;
                break;

            case 'PurchaseRequest':
                title = 'Solicitud de Compra  ' + complemento;
                break;

            default:

        }

        return title;
    };

    renderContentColumnCreate = () => {
        const { view, newOrderModel } = this.props;
        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'suggestRefill':
                title = this.renderHeaderSuggestRefill();
                break;
            case 'PurchaseRequest':
                title = this.renderDocumentHeaderPurchaseRequest();
                break;
            case 'transfersRequest':
                title = this.renderDocumentTransfersHeader();
                break;

            default:
        }

        return title;
    };

    renderPartidasColumnCreate = () => {
        const { view, newOrderModel } = this.props;
        let title = '';
        switch (newOrderModel.OriginDocumentCreate) {
            case 'suggestRefill':
                title = this.renderContentRefillDoc();
                break;
            case 'PurchaseRequest':
                title = this.renderDocumentBody();
                break;
            case 'transfersRequest':
                title = this.renderDocumentTransfersBody();
                break;
            default:
        }

        return title;
    };


    renderContentColumnTwoCreate = () => {
        const { view, newOrderModel } = this.props;

        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'suggestRefill':
                title = this.renderDocumentFooter();
                break;
            case 'PurchaseRequest':
                title = this.renderDocumentFooter();
                break;
            case 'transfersRequest':
                title = this.renderTransfersFooter();
                break;

            default:
        }

        return title;
    };


    editMode = () => {
        const recoveryModel = JSON.parse(JSON.stringify(this.props.newOrderModel));
        this.setState({ editMode: !this.state.editMode, recoveryModel });
    };

    cancelEditMode = () => {
        this.setState({ editMode: false });
        this.refreshModel(this.state.recoveryModel);
    };

    renderEditButton = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;
        const status = newOrderModel.StatusDocument === 'Cerrado' ? 0 : 1;

        if (action === 2 && !editMode) {
            if (status === 1) {
                return (
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn btn-editar"
                        onClick={this.editMode}>
                        <i className="fas fa-edit  fa-lg" />
                        Editar
                    </button>
                );
            }
        }
    };

    renderEditButton2 = () => {
        return (
            <div>
                <button style={{ backgroundColor: 'transparent', color: '#fff' }} className="btn btn-editar" disabled="true">
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            </div>
        );
    };

    //#region ######### REFILL MODULE #########
    UpdateNewOrderModelKey = (key, value) => {
        const { newOrderModel } = this.props;
        newOrderModel[key] = value;
        this.refreshModel(newOrderModel);
    }


    LoadSuggestRefillLines = async () => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;

        const data = {
            newOrderModel
        }
        enableSpinner(true);
        showAlert({ type: 'info', message: 'Un momento por favor, estamos calculando los artículos sugeridos ', timeOut: 6000 });
        const responseApi = await apiClient.getSuggestItemsBySuc(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return;
        }

        await this.AddItemRefillDoc(responseApi.data, true)
    }

    OpenItemsRefillDoc = async () => {

    }

    OpenItemsGroups = async () => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        let groupData = []
        if (this.state.ListItemsGroup.length === 0) {
            enableSpinner(true)
            const GroupsItemData = await apiClient.getGroupsItemData();
            groupData = GroupsItemData.data.GrupoArticulo ?? [];
            enableSpinner(false)
        } else {
            groupData = this.state.ListItemsGroup ?? []
        }

        await this.setState({
            ListItemsGroup: groupData,
            mountStandarSelectM: true,
        });
        $("#selectItemsGroup").modal("show");
        $('#selectItemsGroup').on('hidden.bs.modal', () => this.setState({ mountStandarSelectM: false }));
    }

    openItemsRefillModal = async (searchingItem = null, searchByGrp = false) => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        const searchItem = searchingItem !== null ? searchingItem : newOrderModel.searchItem;

        const data = {
            searchItem: searchItem,
            searchItemsByGrp: searchByGrp
        }

        enableSpinner(true);
        const getItemResponse = await apiClient.getSuggestRefillItems(data);
        enableSpinner(false);

        if (getItemResponse.data.length === 0) {
            if (!Array.isArray(getItemResponse.data.results)) {
                showAlert({ type: 'info', message: getItemResponse.message });
                return;
            }
            if (getItemResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getItemResponse.data.length === 1 || (getItemResponse.data.length > 1 && searchByGrp)) {
            this.setState({
                items: getItemResponse.data
            });
            await this.AddItemRefillDoc(getItemResponse.data)
        } else {
            this.setState({
                items: getItemResponse.data,
                mountStandarSelectItems: true,
            });
            $('#selectRefillItems').modal('show');
            $('#selectRefillItems').on('hidden.bs.modal', () => this.setState({ mountStandarSelectItems: false }));
        }
    };

    AddItemRefillDoc = async (arrayItems, comeFromBot = false) => {
        const { newOrderModel } = this.props
        const { _user } = this.state
        const projectWhs = _user.Branch.ProjectCode || null;
        let auxCopy = newOrderModel.Items.slice();
        newOrderModel.Items = [];
        const taxRateByBranch = (_user?.Branch?.IsBorder || 'N') === 'Y' ? 8 : 16
        for (let n = 0; n < arrayItems.length; n++) {
            const ItemInfo = arrayItems[n];
            const newItemModel = new NewItem();
            newItemModel.LineNum = n;
            newItemModel.LineStatus = true; // 'O'
            newItemModel.ItemCode = ItemInfo.ItemCode;
            newItemModel.ItemName = ItemInfo.ItemName;
            newItemModel.Description = ItemInfo.ItemName;
            newItemModel.whsSelected = true;
            newItemModel.WhsCode = projectWhs;
            newItemModel.OnHand = ItemInfo.OnHand || 0;
            newItemModel.WhsName = _user.Branch.AccountDefault[0].WhsName;
            newItemModel.Price = parseFloat(ItemInfo?.AvgPrice || 0)
            newItemModel.HomePrice = parseFloat(ItemInfo?.AvgPrice || 0)
            newItemModel.TaxeRate = taxRateByBranch
            newItemModel.RutaOnHand = ItemInfo.RutaOnHand || 0;
            newItemModel.CUsoOnHandGeneral = ItemInfo.CUsoOnHandGeneral || 0;
            newItemModel.MovimientoDiario = ItemInfo.MovimientoDiario || 0;
            if (comeFromBot) newItemModel.Quantity = ItemInfo.Suggest ?? 1;

            newItemModel.MaxStock = ItemInfo.MaxStock ?? 0;
            newItemModel.MinStock = ItemInfo.MinStock ?? 0;
            newItemModel.MinOrder = ItemInfo.MinOrder ?? 0;

            auxCopy.push(newItemModel);
        }
        newOrderModel.Items = auxCopy;
        newOrderModel.searchItem = '';
        await this.refreshModel(newOrderModel);
        this.refreshTotal(newOrderModel);

    }

    ChangeStateField = async (key, value) => {
        await this.setState({
            [key]: value
        })

    }

    openBranches = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let response = await apiClient.listBranches();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            branches: response.data,
        });

        $('#branchesModal').modal('show');
    };

    renderHeaderSuggestRefill = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Nombre del solicitante*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre de solicitante</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.UserName ? newOrderModel.UserName : ''}
                        />
                    </div>
                    {/*Sucursal*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            disabled="true"
                            value={newOrderModel.BranchName ? newOrderModel.BranchName : ''}
                        />
                        {/* {(action === 1 || (action === 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                disabled
                                onClick={this.openBranches}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )} */}
                    </div>

                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {action === 2 &&
                        <>
                            {/*N°:*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtNo"
                                    disabled="true"
                                    value={newOrderModel.DocNum ? newOrderModel.DocNum : ''}
                                />
                            </div>
                            {/*N°:*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Folio</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtNo"
                                    disabled="true"
                                    value={newOrderModel.NumAtCard ? newOrderModel.NumAtCard : ''}
                                />
                            </div>
                            {/*Estado*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtStatus"
                                    disabled="true"
                                    value={newOrderModel.DocStatus ? newOrderModel.DocStatus === 'O' ? 'Abierto' : 'Cerrado' : ''}
                                />
                            </div>
                        </>

                    }


                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            className=" form-control"
                            id="txtStatus"
                            autoComplete="off"
                            max='9999-12-31'
                            disabled="true"
                            value={newOrderModel.DocDate ? moment(newOrderModel.DocDate).format('YYYY-MM-DD') : ''}
                        />
                    </div>

                    {/*>Fecha de vencimiento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Vencimiento</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            autoComplete="off"
                            max='9999-12-31'
                            onChange={(event) => this.UpdateNewOrderModelKey('DocDueDate', event.target.value)}
                            disabled={action === 2 && !editMode ? true : false}
                            value={newOrderModel.DocDueDate ? moment(newOrderModel.DocDueDate).format('YYYY-MM-DD') : ''}
                        />
                    </div>



                </div>
            </div>
        );

    };

    selectItmGrp = async (data) => {
        this.openItemsRefillModal(data.ItmsGrpCod, true)
        $("#selectItemsGroup").modal("hide");
    }

    SelectMuchRefillItems = async (data = []) => {
        const { items } = this.state
        const selectItems = items.filter((item) => data.includes(item.ItemCode));
        this.AddItemRefillDoc(selectItems)
        $('#selectRefillItems').modal('hide');
    }

    DeleteItemRefillDoc = (index) => {
        const { newOrderModel } = this.props
        let newArray = newOrderModel.Items.slice();
        newOrderModel.Items = [];
        newArray.splice(index, 1); // 1 es la cantidad de elementos a eliminar
        newOrderModel.Items = newArray;
        this.refreshTotal(newOrderModel);
    }

    ChangeLineFieldValue = async (index, key, value) => {
        const { newOrderModel } = this.props
        const newArray = newOrderModel.Items.slice();
        newOrderModel.Items = [];
        newArray[index][key] = value;
        newOrderModel.Items = newArray;
        await this.refreshModel(newOrderModel)
        if (key === 'Quantity') {
            this.refreshTotal(newOrderModel, index)
        }
        document.getElementById(`refillLine-${index}`).focus()
    }

    renderContentRefillDoc = () => {
        const { newOrderModel, action } = this.props
        const { viewTabRefill, editMode } = this.state;
        const headers = [{ title: "Artículo" }, { title: "Descripción" }, { title: "Almacén" }, { title: "Capital, Max" }, { title: "Capital Min." }, { title: "Stock Nece." }, { title: "Existencia" }, { title: "En Ruta" }, { title: "Cesion Uso General" }, { title: "Cesion Uso Día" }, { title: "Solicitado" }, { title: "ACCIONES" },]
        const SuggestDocTools = {
            action,
            editMode,
            ChangeFieldValue: this.ChangeLineFieldValue
        };

        return (
            <div className="row">

                {this.state.mountStandarSelectM &&
                    <StandardSelectModal
                        id="selectItemsGroup"
                        title="Grupos de artículos"
                        data={this.state.ListItemsGroup}
                        selectAction={this.selectItmGrp}
                        searchBar={this.state.searchItmGrp}
                        headers={[
                            { title: "Código", value: true, filter: true, field: "ItmsGrpCod", format: null, classes: "text-left" },
                            { title: "Nombre", value: true, filter: true, field: "ItmsGrpNam", format: null, classes: "text-left" },
                        ]}
                        actPos="start" />
                }

                {this.state.mountStandarSelectItems &&

                    <StandardSelectModal
                        disabled={action === 2 && !editMode}
                        id="selectRefillItems"
                        title="Artículos"
                        data={this.state.items}
                        selectAction={(data) => this.SelectMuchRefillItems(data)}
                        selectedItems={this.state.chooseRefillItems}
                        headers={[
                            { title: "Código", value: true, filter: true, field: "ItemCode", format: null, classes: "text-left" },
                            { title: "Nombre", value: true, filter: true, field: "ItemName", format: null, classes: "text-left" },
                            { title: "Stock", value: true, filter: true, field: "OnHand", format: null, classes: "text-left" },
                        ]}
                        actPos="start"
                        selection="multiple"
                        idSelection="ItemCode"
                        warningQtySelection={50}
                        limitQtySelection={100}
                        validNoSelection={true} />
                }


                <div className='col-12 mb-3'>
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">

                            <a
                                className={`nav-item nav-link font-weight-bold text-secondary ${viewTabRefill === 2 ? 'active' : ''}`}
                                id="nav-profile-tab-refillContent"
                                data-toggle="tab"
                                href="#refillContent"
                                role="tab"
                                onClick={() => this.ChangeStateField('viewTabRefill', 2)}
                                aria-controls="refillContent" >
                                Partidas resurtido
                            </a>

                        </div>
                    </nav>

                    <div className="tab-content">
                        <div className={`w-100 table-scroll border border-top-0 rounded-bottom tab-pane tab-pane p-3 ${viewTabRefill === 2 ? 'active' : ''}`} role="tabpanel" aria-labelledby="nav-profile-tab-List" >
                            {viewTabRefill === 2 &&
                                <>
                                    {action === 1 && (
                                        <div className="row mt-2">
                                            <div className="col-12 col-md-6">
                                                {/*Search field suggest */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Articulo</span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={newOrderModel.searchItem || ''}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.openItemsRefillModal();
                                                            }
                                                        }}
                                                        onChange={event => this.changeSearchItem(event)}
                                                    />

                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => this.OpenItemsRefillDoc()}
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => this.OpenItemsGroups()}
                                                    >
                                                        <i className="fa fa-bars" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>

                                            {/*Segunda columna*/}
                                            <div className="col-12 col-md-6">

                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent' }}
                                                    className="input-group-text"
                                                    onClick={() => this.LoadSuggestRefillLines()}
                                                >
                                                    {/* <i class="fa fa-android" aria-hidden="true"></i> */}
                                                    Cargar sugeridos
                                                </button>
                                            </div>
                                        </div>
                                    )}


                                    <GenericTable
                                        headers={headers}
                                        data={newOrderModel.Items}
                                        view={'suggestRefillDoc'}
                                        idTable={'suggestRefillDoc'}
                                        actionLabel={"Eliminar"}
                                        enableSearchInTable={true}
                                        action={this.DeleteItemRefillDoc}
                                        viewTools={SuggestDocTools}
                                    />
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div >
        )

    }

    //#endregion

    openAlmacen = async (index, warehouse, itemCode = null) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        //#region ########## BATCH ####################################

        if (newOrderModel.DocType === "I") {
            if (view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isConfigured = false;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        if (item.BatchNumbers && item.BatchNumbers.length > 0) {
                            isConfigured = true;
                        }
                    }
                    if (isConfigured) {
                        $('#validationBatchsModal').modal('show');
                    } else {
                        await this.SearchAlmacen(index, warehouse, itemCode);
                    }
                } else {
                    await this.SearchAlmacen(index, warehouse, itemCode);
                }
            } else if (view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isConfigured = false;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        if (item.BatchNumbers && item.BatchNumbers.length > 0) {
                            isConfigured = true;
                        }
                    }
                    if (isConfigured) {
                        let searchWhs = {
                            index,
                            warehouse,
                            itemCode
                        }

                        await this.setState({
                            SearchWhs: searchWhs,
                        });
                        $('#validationBatchsModal').modal('show');
                    } else {
                        await this.SearchAlmacen(index, warehouse, itemCode);
                    }
                } else {
                    await this.SearchAlmacen(index, warehouse, itemCode);
                }
            } else {
                await this.SearchAlmacen(index, warehouse, itemCode);
            }
        } else {
            await this.SearchAlmacen(index, warehouse, itemCode);
        }

        //#emdRegion
    };

    SearchAlmacen = async (index, warehouse, itemCode = null) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;

        if (newOrderModel.OriginDocumentCreate !== 'transfersRequest' && newOrderModel.OriginDocumentCreate !== 'transfers' && newOrderModel.OriginDocumentCreate !== 'reportSelectionCriteria') {
            this.validateWhsEnter(1, index);
        }

        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'PurchaseRequest' && view !== 'reportSelectionCriteria') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        let data = null;

        if (view === 'transfersOutput' || view === 'ExitHelmets') {
            data = {
                TransferType: 'O',
                ItemCode: itemCode,
            }
        } else if ((newOrderModel.OriginDocumentCreate === 'transfersRequest' || newOrderModel.OriginDocumentCreate === 'transfers' || newOrderModel.OriginDocumentCreate === 'reportSelectionCriteria') && !itemCode) {
            data = {
                TransferType: null,
                ItemCode: null
            }
        } else {
            data = {
                TransferType: 'I',
                ItemCode: itemCode
            }
        }

        let almacen = {};

        let whCode = newOrderModel.Items[index] ? newOrderModel.Items[index].WhsCode !== "" ? newOrderModel.Items[index].WhsCode : '' : '';

        if (warehouse === 2) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.Filler || '',
            }
            data.whsCode = newOrderModel.Filler || '';
        } else if (warehouse === 3) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.ToWhsCode || '',
            }
            data.whsCode = newOrderModel.ToWhsCode || '';
        } else if (warehouse === 3) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.ToWhsCode || '',
            }
            data.whsCode = newOrderModel.ToWhsCode || '';
        } else {
            almacen = {
                item: itemCode,
                whsCode: whCode || '',
            }
            data.whsCode = whCode || '';
        }

        let getAlmacenResponse = null;
        enableSpinner(true);
        getAlmacenResponse = await apiClient.getWarehouse(almacen);

        if (getAlmacenResponse.data.length === 0 || (getAlmacenResponse.data.length && whCode)) {
            if (getAlmacenResponse.data.length && whCode) {
                data.whsCode = '';
            }

            getAlmacenResponse = await apiClient.getWarehouseList(data);
            enableSpinner(false);

            if (!Array.isArray(getAlmacenResponse.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }

            if (getAlmacenResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            if (getAlmacenResponse.data.length === 1) {
                this.setState({
                    warehouses: getAlmacenResponse.data,
                    itemOrderModelUpdate: index,
                    warehouseUpdate: warehouse,
                });


                this.selectAlmacenEnter(getAlmacenResponse.data[0]);
            } else {
                this.setState({
                    warehouses: getAlmacenResponse.data,
                    itemOrderModelUpdate: index,
                    warehouseUpdate: warehouse,
                    itemSelected: itemCode
                });
                $('#almacenDocumentsModal').modal('show');
            }


        } else {
            this.setState({
                warehouses: getAlmacenResponse.data,
                itemOrderModelUpdate: index,
                warehouseUpdate: warehouse,
                itemSelected: itemCode
            });
            enableSpinner(false);
            this.selectAlmacenEnter(getAlmacenResponse.data[0]);
        }
    };

    selectAlmacen = async action => {
        const { warehouses, itemOrderModelUpdate, warehouseUpdate, _user } = this.state;
        const { newOrderModel, showAlert, view } = this.props;
        let warehouse = warehouses[action.index];

        if (warehouseUpdate === 1) {
            if (_user?.FMB_Role === 'counter1') {
                showAlert({ type: 'warning', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
                return;
            }
            newOrderModel.Items[itemOrderModelUpdate].WhsCode = warehouse.WhsCode || '';
            newOrderModel.Items[itemOrderModelUpdate].WhsName = warehouse.WhsName || '';
            newOrderModel.Items[itemOrderModelUpdate].OnHand = warehouse.OnHand || 0;
            newOrderModel.Items[itemOrderModelUpdate].AvgPrice = warehouse.AvgPrice || 0;
            newOrderModel.Items[itemOrderModelUpdate].AcctCode = warehouse.AcctCode || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCode2 = warehouse.AcctCode2 || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCodeName = warehouse.AcctName || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode = warehouse.FormatCode || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode2 = warehouse.FormatCode2 || '';
            if (newOrderModel.U_TipoSalida !== '') {
                let data = {
                    Type: newOrderModel.U_TipoSalida,
                    WhsCode: newOrderModel.Items[itemOrderModelUpdate].WhsCode,
                }

                let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                if (responseGetAcctCode.status === 1) {
                    if (responseGetAcctCode.data[0].AcctCode !== '') {
                        const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                        const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                        const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                        newOrderModel.Items[itemOrderModelUpdate].FormatCode = resultado;
                        newOrderModel.Items[itemOrderModelUpdate].AcctCode = cuentaOriginal;
                    }
                }
            }
            newOrderModel.CashAcct = warehouse.CashAccount || '';
            newOrderModel.BpAct = warehouse.ControlAccount || '';
            // Precio x Kilo
            let PriceKilo = await apiClient.getPriceKilo(newOrderModel.Items[itemOrderModelUpdate].ItemCode, warehouse.WhsCode);
            newOrderModel.Items[itemOrderModelUpdate].PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            newOrderModel.Items[itemOrderModelUpdate].UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            // Precio x Kilo
            newOrderModel.Items[itemOrderModelUpdate].wareHouseStock.map(warehouseStock => {

                if (newOrderModel.Items[itemOrderModelUpdate].InvntItem === 'N') {
                    return;
                }

                if (warehouseStock.WhsCode === warehouse.WhsCode) {
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newOrderModel.Items[itemOrderModelUpdate].SalPackUn : newOrderModel.Items[itemOrderModelUpdate].PurPackUn;
                    if (warehouseStock.OnHand <= 0
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;

                    } else if ((newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'Y' && newOrderModel.Items[itemOrderModelUpdate].Quantity > warehouseStock.OnHand) ||
                        (newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'N' && (newOrderModel.Items[itemOrderModelUpdate].Quantity * measureUnit) > warehouseStock.OnHand)
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].stock = true;
                    }
                }
            })
        }
        //ALMACEN ORIGEN
        if (warehouseUpdate === 2) {
            if (itemOrderModelUpdate === null) {
                newOrderModel.Filler = warehouse.WhsCode || '';
                newOrderModel.FillerName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].Filler = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].FillerName = warehouse.WhsName || '';
            }

            newOrderModel.Items.map(item => {
                item.wareHouseStock.map(warehouse => {
                    if (warehouse.WhsCode === newOrderModel.Filler) {
                        if (warehouse.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            item.stock = false;
                        } else {
                            item.stock = true;
                        }
                    }
                });
            });

        }
        //ALMACEN DESTINO
        if (warehouseUpdate === 3) {
            if (itemOrderModelUpdate === null) {
                newOrderModel.ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.ToWhsCodeName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCodeName = warehouse.WhsName || '';
            }
        }
        //ALMACEN TRANSITO
        if (warehouseUpdate === 4) {
            newOrderModel.wareHouseFinalOptional = true;
            newOrderModel.wareHouseFinalOptionalValue = warehouse.WhsCode || '';
        }
        if (warehouseUpdate === 5) {
            newOrderModel.Items[itemOrderModelUpdate].AvgPrice = warehouse.AvgPrice || 0;
        }
        if (warehouseUpdate === 117) {
            newOrderModel.WarehouseCEDIS = warehouse.WhsCode
        }

        this.refreshModel(newOrderModel);
        if (newOrderModel.OriginDocumentCreate !== 'transfersRequest' && newOrderModel.OriginDocumentCreate !== 'transfers') {
            this.validateWhsEnter(2, itemOrderModelUpdate);
        }
        setTimeout(() => {
            this.setState({
                warehouses: [],
                itemOrderModelUpdate: null,
                itemSelected: '',
            });
        }, 100);
        $('#almacenDocumentsModal').modal('hide');
    };

    validateWhsEnter = (option, index) => {
        let { newOrderModel } = this.props;


        if (option === 1) {
            newOrderModel.Items[index].whsSelected = false;

        }
        if (option === 2) {
            newOrderModel.Items[index].whsSelected = true;
        }
        this.refreshModel(newOrderModel);
    };


    openSeries = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.SerieArray.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setTimeout(() => {
            this.setState({
                series: newOrderModel.SerieArray,
            });
            $('#seriesDocumentsModal').modal('show');
        }, 100);
    };

    selectSeries = action => {
        const { partners } = this.state;
        const { newOrderModel, view } = this.props;
        let serie = newOrderModel.SerieArray[action.index];
        newOrderModel.SerieName = serie.SeriesName || '';
        newOrderModel.SerieCode = serie.Series || '';
        newOrderModel.NextFolio = serie.NextNumber || '';


        this.refreshModel(newOrderModel);
        $('#seriesDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                series: [],
            });
        }, 100);
    };

    selectBranches = action => {
        const { branches } = this.state;
        const { newOrderModel } = this.props;
        let branch = branches[action.index];

        newOrderModel.Branch = branch.Code || '';
        newOrderModel.BranchName = branch.Name || '';

        this.refreshModel(newOrderModel);
        $('#branchesModal').modal('hide');
    };

    render() {
        const { action, view, newOrderModel } = this.props;
        const { isSelectTo, isSelectOf } = newOrderModel;
        const status = newOrderModel.StatusDocument === 'Cerrado' ? 0 : 1;
        const { editMode, items, pageTotal, warehouses, itemSelected, series, showWarningModal, branches } = this.state;
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll" id="SuggestRefillModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ zIndex: 90 }}>
                <ConfirmModal
                    CloseDocumentModal={() => { }}
                />

                {this.state.mountItemCreateModal &&
                    <ItemsCreateModal
                        data={items}
                        totalPage={pageTotal}
                        newOrderModel={newOrderModel}
                        mainView={view}
                        selectItems={this.selectItems}
                        cleanData={() => this.setState({ items: [] })}
                        refreshItems={this.refreshItems}
                    />
                }

                <AlmacenModal
                    data={warehouses}
                    view={view}
                    itemSelected={itemSelected}
                    selectAlmacen={this.selectAlmacen}
                    cleanData={() => this.setState({ warehouses: [], itemSelected: '' })} />

                <SeriesCreateModal
                    data={series}
                    selectSerie={this.selectSeries}
                    cleanData={() => this.setState({ series: [] })} />
                <BranchesModal
                    data={branches}
                    selectBranches={this.selectBranches}
                    cleanData={() => this.setState({ branches: [] })}
                />

                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {this.renderTitleModal()}
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            {this.renderContentColumnCreate()}
                            {/* <tr className="row">
                                {this.renderEditButton()}
                                {this.renderEditButton2()}
                            </tr> */}
                            {this.renderPartidasColumnCreate()}
                            {this.renderContentColumnTwoCreate()}
                        </div>

                        <div className="modal-footer">
                            {status === 1 && Number(action) === 2 && !editMode && (
                                <label className="btn text-white copiarA">
                                    <select name="select" className="btn botonCorrect text-white copiarAA"
                                        value={'--'}
                                        onChange={this.selectTo}
                                    >
                                        <option value="--">Copiar a ...</option>
                                        {/* <option value={"PurchaseRequest"}>Solicitud de compra</option> */}
                                        <option value={"transfersRequest"}>Solicitud de traslado</option>

                                    </select>
                                </label>
                            )}

                            {Number(action) === 1 && (!isSelectTo || !isSelectOf) &&
                                (view === 'invoice' || view === 'deliveries' || view === 'debitNote' || view === 'creditNote' || view === 'return' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'ExitHelmets' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'transfers' || view === 'landedCosts') &&
                                (newOrderModel.Items.length === 0) &&
                                (
                                    <label className="btn botonCorrect text-white">
                                        <select name="select" className="btn botonCorrect text-white" value={'--'}
                                            onChange={this.selectOf}>
                                            <option value="">Copiar de ...</option>
                                            <option value="">Copiar de ...</option>

                                        </select>

                                    </label>
                                )
                            }

                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModalCreate}>
                                Cerrar
                            </button>

                            {Number(action) === 1 && view !== 'reportSelectionCriteria' && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.openConfirm}>
                                    Crear
                                </button>
                            )}

                            {Number(action) === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {Number(action) === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}

                        </div>
                    </div>
                </div>
                {this.openAction()}
                {showWarningModal &&
                    <WarningModal
                        title="Advertencia"
                        message="¿Deseas continuar?"
                        btnAccept="Si"
                        btnCancel="No"
                        size="modal-md"
                        accept={this.sendModel}
                        cancel={() => $("#warningModal").modal("hide")} />
                }
            </div>
        );
    }
}

export default SuggestRefillModal;